export const nl = {
  " custom-content": {
    "modal_delete": {
      "submit": "verwijderen",
      "title ": "\"{{title}}\" verwijderen?"
    }
  },
  "alert": {
    "no_assignment_theory_found": "Er is geen theorie beschikbaar."
  },
  "arrange": {
    "arrangement_card": {
      "edit_name_description": "Naam en omschrijving wijzigen",
      "last_edit_on": "Laatst bewerkt op: {{date}} om {{time}}",
      "last_modified_by": "Laatst bewerkt door: {{lastModifiedBy}}",
      "linked_to": "Gekoppeld aan:",
      "linked_to_unknown": "{{ unknownGroupsCount }} groep(en) waar je geen onderdeel van bent",
      "no_description": "Geen omschrijving",
      "owner": "Eigenaar: {{owner}}",
      "template_subtitle_empty": "Start vanuit een volledig leeg arrangement",
      "template_subtitle_predefined": "Gebruik dit als basis voor een nieuw arrangement.",
      "to_teaching_material": "Bekijk lesstof"
    },
    "button": {
      "create_arrangement": "Arrangement aanmaken"
    },
    "common": {
      "alert": {
        "no_search_results": "Geen resultaten gevonden voor <span class=\"empty-message-bold\">'{{ query }}'</span>."
      },
      "screen_too_small": "Dit formaat scherm is te klein voor het aanmaken en bewerken van een arrangement. Gebruik een groter scherm om zelf een arrangement samen te stellen.",
      "search_total_all": "{{ count }} resultaten",
      "search_total_one": "{{ count }} resultaat",
      "search_total_onesome": "{{ filteredAmount }} van {{ count }} resultaat",
      "search_total_some": "{{ filteredAmount }} van {{ count }} resultaten",
      "search_total_zero": "geen resultaten",
      "student_type": {
        "bo": "studenten",
        "default": "leerlingen",
        "vo": "leerlingen"
      }
    },
    "content": {
      "confirm_delete_not_your_arrangement": "Let op! Dit arrangement is origineel niet door jou gemaakt. Weet je zeker dat je het arrangement wil verwijderen?",
      "confirm_duplicate": "Weet je zeker dat je arrangement '{{ arrangement }}' wilt dupliceren?",
      "confirm_remove_connected_group": "Let op! Met deze actie is het arrangement niet meer te openen, ook niet door studenten! Door studenten behaalde resultaten zullen niet meer zichtbaar zijn.",
      "confirm_save_not_your_arrangement": "Let op! Dit arrangement is origineel niet door jou gemaakt. Weet je zeker dat je de wijzigingen op wil slaan?",
      "connect_not_yet_connected": "'{{ arrangement }}' is nog niet gekoppeld aan een groep. Zodra je een arrangement koppelt is het zichtbaar voor de gekoppelde groepen.",
      "copy": "(kopie)",
      "date_time": "{{date}} om {{time}}",
      "delete_arrangement": "Weet je zeker dat je '{{ arrangement }}' wilt verwijderen?",
      "empty_title": "Je dient een titel in te vullen",
      "lose_changes_no_items": "Dit is een leeg arrangement en kan daarom niet worden opgeslagen.",
      "manage_groups": "Beheer hier de gekoppelde groepen van '{{ arrangement }}'",
      "multiple_sources": "meerdere bronnen",
      "no_groups_selected": "Geen groepen geselecteerd.",
      "pick_method": "Kies hier de methode waarin je lesmateriaal wil arrangeren.",
      "select_all_schoolyears": "Toon groepen van alle schooljaren.",
      "template_subtitle_empty": "Start vanuit een volledig leeg arrangement",
      "template_subtitle_predefined": "Gebruik dit als basis voor een nieuw arrangement."
    },
    "create_card": {
      "no_title": "Geen titel",
      "subtitle_empty": "Start vanuit een volledig leeg arrangement",
      "subtitle_predefined": "Gebruik dit als basis voor een nieuw arrangement.",
      "title": "Leeg arrangement"
    },
    "create_modal": {
      "create_arrangement": "Arrangement aanmaken",
      "description": "Omschrijving van arrangement",
      "empty_title": "Je dient een titel in te vullen",
      "error": "De gekozen titel is te kort, gebruik minimaal 5 tekens.",
      "new_arrangement": "Nieuw arrangement",
      "new_arrangement_template": "Nieuw arrangement op basis van: {{streamName}}",
      "placeholder_description": "Voeg hier de omschrijving toe (optioneel)",
      "placeholder_title": "Voeg hier de titel toe",
      "title": "Titel van arrangement",
      "title_description": "De titel moet minimaal 5 karakters bevatten"
    },
    "create": {
      "footer_options": "Geen passend arrangement gevonden? Bekijk andere opties:",
      "footer_options_empty": "Geen passend arrangement gevonden? Gebruik een leeg arrangement.",
      "my_arrangements": "Mijn arrangementen",
      "search_placeholder": "Zoek op titel of omschrijving",
      "subtitle_editorial": "Selecteer een basis die bestaat uit de lesstof zoals die in de methode wordt aangeboden. Pas vervolgens de inhoud verder aan om het arrangement volledig te laten aansluiten bij jouw lesdoelen en omstandigheden.",
      "subtitle_predefined": "Selecteer een basis die speciaal is samengesteld voor een specifieke lessituatie. Vervolgens kan je het arrangement gebruiken of het aanpassen om het volledig te laten aansluiten bij jouw lesdoelen en omstandigheden.",
      "title_editorial": "Basisarrangementen",
      "title_predefined": "Voorgestelde arrangementen"
    },
    "delete_modal": {
      "error": {
        "cant_delete_arrangement": "Je arrangement is niet verwijderd, omdat er een technisch probleem is. Probeer het het later nog een keer. Lukt het later nog niet, <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">neem dan contact op met de klantenservice."
      },
      "input": {
        "confirm_not_your_arrangement": "Verwijder '{{ arrangement }}'"
      },
      "not_your_arrangement": {
        "warning": "Let op! Dit arrangement is origineel niet door jou gemaakt. Weet je zeker dat je het arrangement wil verwijderen?"
      },
      "title": "Verwijderen",
      "warning": "Met deze actie wordt het arrangement permanent verwijderd! Wijzigingen in het arrangement zijn niet meer mogelijk en bij de leerling zal het arrangement niet meer actief getoond worden.\n\n"
    },
    "duplicate_modal": {
      "error": {
        "cant_duplicate_arrangement": "Je arrangement is niet gedupliceerd, omdat er een technisch probleem is. Probeer het het later nog een keer. Lukt het later nog niet, <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">neem dan contact op met de klantenservice."
      },
      "subtitle": "Weet je zeker dat je arrangement '{{title}}' wil dupliceren?",
      "title": "Dupliceren"
    },
    "edit_modal": {
      "error": {
        "cant_edit_arrangement": "Je arrangement is niet gewijzigd, omdat er een technisch probleem is. Probeer het het later nog een keer. Lukt het later nog niet, <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">neem dan contact op met de klantenservice."
      },
      "input_description": "Omschrijving van arrangement",
      "input_title": "Titel van arrangement",
      "input_title_description": "De titel moet minimaal 5 karakters bevatten",
      "not_your_arrangement": {
        "warning": "Let op! Dit arrangement is origineel niet door jou gemaakt. Weet je zeker dat je de wijzigingen op wil slaan?"
      },
      "placeholder_description": "Voeg een omschrijving toe (optioneel)",
      "placeholder_title": "Voeg hier de titel toe",
      "title": "Naam en omschrijving wijzigen"
    },
    "edit": {
      "all_learning_items_selected": "Alle leereenheden zijn onderdeel van je arrangement. Verplaats leereenheden die je uit je arrangement wil verwijderen hiernaartoe.",
      "arrange_learning_item_child_active_count": "{{ active }} van {{ total }} leereenheden actief",
      "arrange_learning_item_child_button": "Inhoud arrangeren",
      "available_learning_items": "Beschikbare leereenheden",
      "card": {
        "action": {
          "add_card": "Plaats onderaan arrangement",
          "add_card_tooltip": "Plaats in arrangement",
          "move_card_down": "Verplaats naar beneden",
          "move_card_up": "Verplaats naar boven",
          "remove_card": "Verwijder uit arrangement",
          "show_info": "Bekijk informatie van leereenheid",
          "show_material": "Bekijk lesmateriaal"
        },
        "add_card_tooltip": "Plaats in arrangement",
        "open_menu_tooltip": "Menu openen",
        "remove_card_tooltip": "Verwijder uit arrangement"
      },
      "drag_tooltip": "Sleep om te verplaatsen",
      "empty": "Dit arrangement is leeg. Voeg de leereenheid die je in je arrangement wil hebben hieraan toe.",
      "error": {
        "cant_save_arrangement": "Je arrangement is niet opgeslagen, omdat er een technisch probleem is. Probeer het later nog een keer. Lukt het later nog niet, <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">neem dan contact op met de klantenservice.</a>",
        "toast": {
          "cant_save_arrangement": "Opslaan niet gelukt"
        }
      },
      "filter_button": "Filter resultaten",
      "filter_title": "Filteren",
      "learning_item_not_available": "Dit onderdeel is niet meer beschikbaar.",
      "learning_items": "Leereenheden",
      "my_arrangements": "Mijn arrangementen",
      "no_filter_results": "Er zijn geen beschikbare leereenheden gevonden voor de <span class=\"empty-message-bold\">ingevulde filters</span>.",
      "no_learning_items_available": "De huidige methode heeft geen leereenheden.",
      "no-repair-solution": "Er is geen vervangend onderdeel beschikbaar",
      "options": {
        "information": {
          "description": "Toon beschrijving",
          "learning_items": "Toon leerniveau",
          "title": "Informatie op leereenheden"
        },
        "layout": {
          "grid": "Raster",
          "list": "Lijst",
          "title": "Weergave"
        },
        "sort": {
          "ascending_title": "Titel: A-Z",
          "descending_title": "Titel: Z-A",
          "title": "Sorteren op"
        },
        "title": "Opties"
      },
      "repair_alert": "Het arrangement kan niet worden opgeslagen omdat het onderdelen bevat die niet meer beschikbaar zijn. Repareer het arrangement om het op te kunnen slaan.",
      "repair_alert_one": "Het arrangement kan niet worden opgeslagen omdat het een onderdeel bevat dat niet meer beschikbaar is. Repareer het arrangement om het op te kunnen slaan.",
      "repair_description_one": "Dit arrangement ‘{{arrangement}}’ bevat een onderdeel dat niet meer beschikbaar is. Als je dit arrangement wil opslaan dient dit onderdeel vervangen of verwijderd te worden.\n\nIn het overzicht hieronder zie je of er een vervangend onderdeel beschikbaar is, of dat het onderdeel verwijderd dient te worden.",
      "repair_description_other": "Dit arrangement {{arrangement}} bevat onderdelen die niet meer beschikbaar zijn. Als je dit arrangement wil opslaan dienen deze onderdelen vervangen of verwijderd te worden.\n\nIn het overzicht hieronder zie je of er een vervangend onderdeel beschikbaar is, of dat het onderdeel verwijderd dient te worden.",
      "repair-button": "Repareren",
      "repair-title": "Arrangement repareren",
      "results": "{{filteredAmount}} van $t(arrange.edit.results_total, {\"count\": {{count}}})",
      "results_total": "{{ count }} resultaten",
      "results_total_one": "{{ count }} resultaat",
      "results_total_zero": "geen resultaten",
      "results_zero": "$t(arrange.edit.results_total, {\"count\": {{count}}})",
      "search": "Zoeken & filteren",
      "search-learning-items": "Zoek in de leereenheden",
      "selected": "Jouw arrangement:",
      "subtitle": "Deze leereenheden sleep je naar jouw arrangement om lesmateriaal samen te stellen.",
      "tooltip": {
        "loading_groups_failed": "Er zijn op dit moment geen groepen beschikbaar om te koppelen"
      },
      "unsaved_changes": "Dit arrangement is nog niet opgeslagen. Als je terug gaat zonder op te slaan verlies je mogelijk je wijzigingen.",
      "unsaved_changes_repair": "Je kunt momenteel niet opslaan omdat het arrangement onderdelen bevat die niet beschikbaar zijn. Repareer je arrangement zodat je de wijzigingen kan opslaan."
    },
    "generic": {
      "back_to_my_arrangements": "Terug naar jouw arrangementen"
    },
    "label": {
      "description": "Omschrijving",
      "groups_selected": "{{ selected }} van {{ total }} groepen geselecteerd:",
      "title": "Titel"
    },
    "learning-item-child-modal": {
      "arrangement-items": "Toegevoegde leereenheden",
      "available-items": "Beschikbare leereenheden",
      "items": {
        "arrange": {
          "empty": "Er zijn geen toegevoegde leereenheden. Voeg minimaal 1 leereenheid hieraan toe."
        },
        "arrangement": {
          "empty": "Je arrangement is nog leeg. Voeg lesstof toe aan je arrangement door hier naartoe te slepen."
        },
        "available": {
          "empty": "Alle leereenheden zijn toegevoegd. Verplaats leereenheden die je wilt verwijderen hier naartoe."
        }
      },
      "submit": "Bijwerken",
      "title": "Arrangeer inhoud van: {{learningItem}}"
    },
    "link_groups": {
      "all_groups_are_selected": "Alle groepen zijn gekoppeld",
      "error": {
        "cant_link_groups": "Het koppelen van groepen aan jouw arrangement is niet gelukt, omdat er een technisch probleem is. Probeer het het later nog een keer. Lukt het later nog niet, <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">neem dan contact op met de klantenservice."
      },
      "no_groups_available": "Er zijn geen groepen beschikbaar",
      "no_groups_available_manage": "Je hebt geen groepen om te koppelen. Maak eerst een groep aan via <a href=\"{{groupServiceLink}}/\" target=\"_blank\">Groepenbeheer</a> om je arrangement te kunnen delen met {{ studentType }}.",
      "select_groups": "Selecteer een groep",
      "subtitle": "Beheer hier de gekoppelde groepen van '{{ arrangement }}'.",
      "title": "Koppelen",
      "unknown_groups_warning": "Let op! Dit arrangement is gekoppeld aan {{ unknownGroupsCount }} groep(en) waar je geen onderdeel van bent. Deze groepen kunnen niet getoond worden en niet ontkoppeld worden.",
      "unlink_group_warning": "Let op! Wanneer je opslaat worden er een of meerdere groepen ontkoppeld. Het arrangement is daardoor niet meer bereikbaar voor de {{ studentType }} in deze groep(en)! Behaalde resultaten zullen niet meer inzichtelijk zijn."
    },
    "methods": {
      "arrange_in": "Arrangeren in eDition",
      "pick_method": "Kies hier de methode waarin je lesmateriaal wil arrangeren."
    },
    "new_arrangement_banner": {
      "editorial": {
        "button": "Bekijk opties",
        "description": "Bevat je vertrouwde lesstof als basis. Je gaat arrangeren met de lesstof die je al kent vanuit een leermiddel.",
        "title": "Basisarrangementen"
      },
      "empty": {
        "button": "Gebruik",
        "description": "Een volledig lege basis geeft je de ruimte om vanaf nul te starten met het combineren van lesstof.",
        "title": "Leeg arrangement"
      },
      "hide": "Verberg nieuw arrangement",
      "new_subtitle": "Start met het maken van je eigen unieke arrangement: begin met een bestaand stuk en maak het helemaal van jou.",
      "new_title": "Nieuw arrangement",
      "predefined": {
        "button": "Bekijk opties",
        "description": "Bevat arrangementen die speciaal samengesteld zijn voor specifieke situaties, op basis van bekende lesstof. Zo geef je makkelijk les op jouw manier, wanneer je bijvoorbeeld minder lesuren hebt of leerjaren wilt combineren.",
        "title": "Voorgestelde arrangementen"
      },
      "show": "Nieuw arrangement",
      "subtitle": "Stel je eigen lesmateriaal samen. Zo heb je altijd lesmateriaal dat aansluit bij de les die jij wil geven. Je kunt ervoor kiezen om een basis of voorgesteld arrangement aan te passen. Of je kunt een volledig eigen arrangement samenstellen.",
      "title": "Arrangeren"
    },
    "overview": {
      "confirm_delete_not_your_arrangement": "Let op! Dit arrangement is origineel niet door jou gemaakt. Weet je zeker dat je het arrangement wil verwijderen?",
      "confirm_duplicate": "Weet je zeker dat je arrangement '{{ arrangement }}' wil dupliceren?",
      "confirm_remove_connected_group": "Let op! Met deze actie is het arrangement niet meer bereikbaar voor de student! Door studenten behaalde resultaten zullen door student en ook docent niet meer inzichtelijk zijn.",
      "confirm_save_not_your_arrangement": "Let op! Dit arrangement is origineel niet door jou gemaakt. Weet je zeker dat je de wijzigingen op wil slaan?",
      "date_time": "{{date}} om {{time}}",
      "delete_arrangement": "Weet je zeker dat je '{{ arrangement }}' wilt verwijderen?",
      "error": {
        "cant_load_arrangements": "Het laden van jouw arrangementen is niet gelukt omdat er een technisch probleem is. Probeer het het later nog een keer. Lukt het later nog niet, <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">neem dan contact op met de klantenservice."
      },
      "my_arrangements": "Mijn arrangementen",
      "new_arrangement": "Nieuw arrangement",
      "no_arrangements_available": "Je hebt nog geen eigen arrangementen. Begin met het maken van een nieuw arrangement en pas het aan naar jouw wensen.",
      "no_filter_results": "Geen resultaten gevonden voor '{{ query }}'. Probeer een ander zoekwoord voor nieuwe resultaten.",
      "switch_to_admin": "Arrangeer als admin",
      "switch_to_instructor": "Arrangeer als docent",
      "your_arrangements": "Mijn arrangementen"
    },
    "page-title": {
      "admin-prefix": "Admin ",
      "create": "Aanmaken arrangement - {{methodName}}",
      "edit": "Arrangement bewerken - {{methodName}}: {{arrangementTitle}}",
      "methods": "Arrangeren methode overzicht",
      "overview": "Arrangement overzicht - {{methodName}}"
    },
    "placeholder": {
      "descriprion": "Voeg hier de omschrijving toe (optioneel)",
      "title": "Voeg hier de titel toe"
    },
    "title": {
      "arrange_in": "Arrangeren in eDition"
    }
  },
  "arrangement": {
    "about": {
      "authors_default": "De auteurs zijn bij ThiemeMeulenhoff bekend.",
      "authors_title": "Auteursinformatie",
      "copyright_content": "&copy; ThiemeMeulenhoff, Amersfoort, {{year}}\n\nAlle rechten voorbehouden. Tekst- en datamining, AI-training en vergelijkbare technologieën niet toegestaan. Niets uit deze uitgave mag worden verveelvoudigd, opgeslagen in een geautomatiseerd gegevensbestand, of openbaar gemaakt, in enige vorm of op enige wijze, hetzij elektronisch, mechanisch, door fotokopieën, opnamen, of enig andere manier, zonder voorafgaande schriftelijke toestemming van de uitgever.\n\nVoor zover het maken van kopieën uit deze uitgave is toegestaan op grond van artikel 16B Auteurswet 1912 j° het Besluit van 23 augustus 1985, Stbl. 471 en artikel 17 Auteurswet 1912, dient men de daarvoor wettelijk verschuldigde vergoedingen te voldoen aan Stichting Publicatie- en Reproductierechten Organisatie (PRO), Postbus 3060, 2130 KB Hoofddorp (<a href=\"https://www.stichting-pro.nl/\" target=\"_blank\">Stichting PRO</a>). Voor het overnemen van gedeelte(n) uit deze uitgave in bloemlezingen, readers en andere compilatiewerken (artikel 16 Auteurswet) dient men zich tot de uitgever te wenden. Voor meer informatie over het gebruik van muziek, film en het maken van kopieën in het onderwijs zie <a href=\"https://www.auteursrechtenonderwijs.nl/\" target=\"_blank\">www.auteursrechtenonderwijs.nl</a>.\n\nDe uitgever heeft ernaar gestreefd de auteursrechten te regelen volgens de wettelijke bepalingen. Degenen die desondanks menen zekere rechten te kunnen doen gelden, kunnen zich alsnog tot de uitgever wenden.\n\nThiemeMeulenhoff is sinds 2025 <a href=\"https://climate-id.com/nl/YI43H3\" target=\"_blank\">ClimatePartner</a>-gecertificeerd.",
      "copyright_header": "Copyright",
      "header": "Colofon: {{streamName}}",
      "section_renew": "Samen leren vernieuwen",
      "tm_content": "ThiemeMeulenhoff is een educatieve uitgeverij die zich inzet voor het voortgezet onderwijs en beroepsonderwijs. De mensen van ThiemeMeulenhoff zijn er voor onderwijsprofessionals - met ervaring, expertise en doeltreffende leermiddelen. Ontwikkeld in doorlopende samenwerking met de mensen in het onderwijs om samen het onderwijs nog beter te maken.\n\nWe ontwikkelen lesmethodes die goed te combineren zijn met andere leermiddelen, naar eigen inzicht aan te passen en bewezen effectief zijn. En natuurlijk worden al onze lesmethodes zo duurzaam mogelijk geproduceerd.\n\nZo bouwen we samen met de mensen in het onderwijs aan een mooie toekomst voor de volgende generatie.",
      "tm_header": "Over ThiemeMeulenhoff"
    },
    "actions": {
      "print": "Reader maken",
      "view_readers": "Readers bekijken"
    },
    "assignments": {
      "adaptive_title": "We raden je aan het opdrachtenblok '{{advise}}' te maken op basis van een score van:",
      "button_title_next": "Volgende opdracht",
      "button_title_previous": "Vorige opdracht",
      "collapse": "Verberg resultaten",
      "collapse_adaptive": "Verberg vervolgblokken",
      "complete": {
        "submit": "Afronden",
        "submit_text": "Alle opdrachten zijn afgerond. Lever je zelftoets in om je resultaten te bekijken."
      },
      "expand": "Toon resultaten",
      "expand_adaptive": "Toon vervolgblokken",
      "legend": {
        "answer_send": "Antwoord is ingestuurd",
        "draft": "Antwoord is nog niet af",
        "open_question": "Open opdracht",
        "review_available": "Nakijken kan nu",
        "title": "Legenda"
      },
      "next": "Volgende opdracht",
      "numbering_prefix": "Opdracht",
      "numbering_separator": "van",
      "previous": "Vorige opdracht",
      "results": "resultaten",
      "self_test": {
        "begin": "Start",
        "body": "Je kunt het maken van de zelftoets onderbreken. Alle opgeslagen antwoorden worden bewaard.",
        "has_retry_one": "Er is een vraag waarvan je het antwoord hebt aangepast na het opslaan. Ga naar de vraag om je aangepaste antwoord op te slaan of lever de toets in.",
        "has_retry_other": "Er zijn vragen waarvan je het antwoord hebt aangepast na het opslaan. Ga naar de vragen om je aangepaste antwoorden op te slaan of lever de toets in.",
        "has_retry_zero": "Er is een vraag waarvan je het antwoord hebt aangepast na het opslaan. Ga naar de vraag om je aangepaste antwoord op te slaan of lever de toets in.",
        "introduction": "Introductie",
        "next_self_score": "Naar volgende open opdracht",
        "result": "Resultaat",
        "results": "Naar resultaten",
        "resume": "Doorgaan",
        "selfscore": {
          "multiple": "Geef jezelf een score bij meerdere opdrachten aan de hand van een modelantwoord.",
          "single": "Geef jezelf een score bij 1 opdracht aan de hand van een modelantwoord."
        },
        "submit": "Inleveren",
        "submit_text": "Je hebt alle opdrachten gemaakt. Lever in om na te kijken."
      },
      "tooltip_self_score": "Zelfscore-opdracht"
    },
    "block": {
      "exercises": "Opdrachten",
      "score": "Score"
    },
    "error": {
      "arrangement_not_found": {
        "message": "Het arrangement dat je probeert te benaderen bestaat niet."
      },
      "method_not_found": {
        "message": "De methode dat je probeert te benaderen bestaat niet."
      },
      "resource_not_found": {
        "message": "Dit arrangement onderdeel kan niet worden geladen."
      }
    },
    "header": {
      "arrangement": "Arrangement",
      "block": "Blok",
      "chapter": "Hoofdstuk",
      "module": "Module",
      "paragraph": "Paragraaf"
    },
    "notification_not_preferred": {
      "action": "Stel hier je voorkeurslesmateriaal in.",
      "action_favorite": "Voeg dit lesmateriaal toe als favoriet",
      "body": "Let op! Je bent nu niet aan het werk in jouw voorkeurslesmateriaal. Weet je zeker dat je hier in wilt werken?",
      "body_favorite": "Let op! Je bent nu niet aan het werk in jouw favoriete lesmateriaal. Weet je zeker dat je hier wilt werken"
    },
    "overview": {
      "button": {
        "continue": "Ga verder",
        "results": "Bekijk",
        "show": {
          "results": "Bekijk resultaten"
        },
        "start": "Start"
      },
      "continue": "Laatst geopend",
      "label": {
        "continue": "Laatst geopend",
        "start": "Start met je lesmateriaal"
      }
    },
    "references": "Bijlagen",
    "resource_toggle_collapsed": "Toon meer",
    "resource_toggle_expanded": "Toon minder",
    "start": "Start",
    "tab": {
      "add_favorite": {
        "aria_label": "Voeg deze stream toe aan jouw favorieten"
      },
      "assignments": "Opdrachten",
      "contents": "Lesstof",
      "exercises": "Opdrachten",
      "instructor_materials": "Docentmateriaal",
      "learning_goals": "Leerdoelen",
      "learning_goals_close_aria_label": "Sluit leerdoelen",
      "remove_favorite": {
        "aria_label": "Verwijder deze stream uit jouw favorieten"
      },
      "sources": "Bronnen",
      "terms": "Begrippen",
      "theory": "Theorie",
      "words": "Woorden"
    }
  },
  "assignment": {
    "action": {
      "correct": "Goed gedaan! Dit antwoord klopt.",
      "incorrect": "Dit is niet het goede antwoord.",
      "missed": "Dit antwoord is goed, maar je koos het niet.",
      "predefined": "Dit antwoord is alvast voor je ingevuld en klopt."
    },
    "actions": {
      "clear_results": "Resultaten wissen",
      "clear_sequence": "Toets wissen",
      "close": "Sluiten",
      "primary": {
        "check": "Nakijken",
        "complete": "Opdracht gedaan",
        "save": "Opslaan",
        "save_edited": "Aangepast antwoord opslaan",
        "submit": "Inleveren"
      }
    },
    "feedback": {
      "deleted_result": "Je docent heeft het antwoord gewist zodat je de opdracht opnieuw kunt maken.",
      "deleted_sequence_result": "Je docent heeft de antwoorden van de zelftoets gewist zodat je de opdrachten opnieuw kan maken.",
      "reset_score": "Je docent heeft het antwoord gewist zodat je de opdracht opnieuw kunt maken.",
      "teacher_message": "Bericht van je docent"
    },
    "header": {
      "back_link": "Terug naar Lesmateriaal"
    },
    "loading": "De opdracht wordt geladen...",
    "question": {
      "result": {
        "actions": {
          "check_results": "Bekijk resultaten",
          "hide_answer": "Verberg antwoord",
          "next_question": "Volgende opdracht",
          "show_answer": "Toon antwoord"
        },
        "check_results": "Je kunt nu de resultaten bekijken.",
        "createdAt": "Nagekeken op {{date}} om {{time}}u",
        "info": {
          "hide_answer": "Verberg het antwoord om de opdracht te kunnen maken"
        },
        "next_question": "Ga door naar de volgende opdracht.",
        "primary": {
          "check": "Maak de opdracht hierboven. Als je klaar bent kun je je antwoord nakijken.",
          "complete": "Maak de opdracht hierboven. Je kunt afronden als je de opdracht hebt gedaan.",
          "submit": "Maak de opdracht hierboven. Je kunt je antwoord inleveren als je klaar bent."
        },
        "review_disabled": "Het nakijken van je antwoord is uitgezet. Als je jezelf wil beoordelen, vraag dan of je docent het nakijken weer wil aanzetten.",
        "self_score": {
          "actions": {
            "confirm_score": "Bevestig score"
          },
          "check_answer_and_score": "Nice! Kijk je antwoord na en geef jezelf hierboven een score.",
          "confirm_score": "Goed gedaan, je kunt nu je score bevestigen."
        },
        "statuses": {
          "checked": {
            "actions": {
              "show_answer": "Toon antwoord",
              "show_answer_info": "Kom je er niet uit? Dan kun je de goede antwoorden bekijken. Je kunt je huidige score van {{score}}% dan niet meer verbeteren.",
              "try_again": "Verbeter antwoord",
              "try_again_info": "(1)[eerste poging];(2)[tweede poging];(3)[derde poging];(4)[vierde poging];(5)[vijfde poging];(6)[zesde poging];(7)[zevende poging];(8)[achtste poging];(9)[negende poging];(10)[tiende poging];(11-inf)[poging {{count}}]"
            },
            "max_score": "Goed gedaan! Je hebt deze opdracht afgerond.",
            "try_again": "Hmm, je antwoord was niet helemaal goed. Probeer het nog een keer."
          },
          "completed": {
            "answer_shown": "Antwoord getoond",
            "attempt": "(1)[Score na eerste poging];(2)[Score na tweede poging];(3)[Score na derde poging];(4)[Score na vierde poging];(5)[Score na vijfde poging];(6)[Score na zesde poging];(7)[Score na zevende poging];(8)[Score na achtste poging];(9)[Score na negende poging];(10)[Score na tiende poging];(11-inf)[Score na poging {{count}}]",
            "default_one": "Je score voor deze opdracht is {{score}}% na {{count}} poging.",
            "default_other": "Je score voor deze opdracht is {{score}}% na {{count}} pogingen.",
            "default_zero": "Je score voor deze opdracht is {{score}}% na {{count}} pogingen.",
            "done": "Je hebt deze opdracht gedaan",
            "message": "Goed gedaan! Je hebt deze opdracht afgerond.",
            "message_closed": "Antwoord getoond",
            "score": "score",
            "self_score": "Je score voor deze opdracht is {{ score }}%."
          },
          "processing": "Pruttel pruttel pruttel...",
          "processing_self_score": "Beep boop beep...",
          "submitted": {
            "actions": {
              "duplicate_value": "Dit antwoord is hetzelfde als het vorige antwoord.",
              "missing_answers": "Je hebt nog niet alle juiste antwoordopties gekozen",
              "try_again_info": "Het antwoord is opgeslagen. Je kunt je antwoord nog aanpassen."
            }
          }
        },
        "validation": {
          "invalid": "Je antwoord is nog niet helemaal goed.",
          "max": "Je hebt het maximaal aantal antwoorden overschreden."
        }
      },
      "validation": {
        "max": "Je hebt te veel antwoorden geselecteerd."
      }
    },
    "results": {
      "average_score_no_scores": "Je hebt opdrachten gemaakt waarvoor je geen score krijgt.",
      "average_score_text": "Je hebt tot nu toe een gemiddelde score van {{score}} over de gemaakte opdrachten.",
      "average_score_title": "Gemiddelde score",
      "average_score_title_selftest": "Score: {{score}}",
      "average_score_title_with_score": "Gemiddelde score: {{score}}",
      "back": "Bekijk al je opdrachten",
      "legenda": {
        "open_assignment": "Open opdracht",
        "title": "Legenda:"
      },
      "loading": "De resultaten worden geladen...",
      "progress_text": "Je hebt {{count}} van de {{total}} opdrachten gemaakt.",
      "progress_title": "Jouw voortgang",
      "progress": {
        "completed": "Je hebt dit opdrachtenblok afgerond met een score van",
        "completed_no_score": "Je hebt dit opdrachtenblok afgerond.",
        "incomplete": "Je hebt nog niet alle opdrachten afgerond."
      },
      "questions_title": "Resultaat per opdracht",
      "questions": {
        "done": "De opdrachten zijn gesorteerd op score. Je kunt de opdrachten met de laagste scores nog eens bekijken.",
        "todo": "Maak de volgende opdrachten om het opdrachtenblok af te ronden."
      },
      "test_ended": "Ingeleverd op {{date}} om {{time}} uur.",
      "test_started": "Gestart op {{date}} om {{time}} uur.",
      "title": "Resultaten",
      "title_selftest": "Resultaten: Zelftoets"
    },
    "score": {
      "message": {
        "excellent": "Super gedaan, ga zo door!",
        "marginal": "Op de goede weg. Oefen nog wat meer!",
        "poor": "Niet erg! Leer van de feedback en probeer het nog eens.",
        "satisfactory": "Netjes! Dit is een mooie score.",
        "unsatisfactory": "Je kunt beter! Oefen nog iets meer."
      }
    },
    "sidebar": {
      "back": "Opdrachtoverzicht",
      "back-to-theory": "Naar theorie",
      "nav": {
        "introduction": "Introductie",
        "results": "Resultaten"
      },
      "navigation": {
        "aria-label": {
          "close": "Inhoudsopgave sluiten",
          "collapse": "Inhoudsopgave inklappen",
          "expand": "Inhoudsopgave uitklappen",
          "open": "Inhoudsopgave openen"
        }
      },
      "secondary": {
        "nav": {
          "alcarta": "Alcarta",
          "book": "Basisboek",
          "sources": "Bronnen",
          "terms": "Begrippen",
          "theory": "Theorie"
        },
        "title": "Hulpmiddelen"
      },
      "support": {
        "tabs": {
          "back_to_theory": "Terug naar Theorie",
          "dynamic": "Bron",
          "sources": "Bronnen",
          "theory": "Theorie"
        }
      },
      "tools": {
        "aria-label": {
          "close": "Theorie sluiten",
          "material": "{{ material }}, opent in een nieuw venster.",
          "open": "Theorie openen"
        }
      }
    },
    "status": {
      "answered": "Antwoord is ingestuurd",
      "checkingAvailable": "Nakijken kan nu",
      "default": "Nog niet gemaakt",
      "disabled": "Beschikbaar na start zelftoets",
      "done": "Antwoord is nagekeken",
      "draft": "Antwoord is nog niet ingestuurd"
    },
    "theory": {
      "alert": {
        "no_assignment_theory_found": "Er is geen theorie beschikbaar bij deze opdrachten. "
      },
      "close-theory": "Theorie sluiten"
    }
  },
  "attempts": {
    "attempts": "Poging {{ attempt }}",
    "final": "Laatste poging"
  },
  "button": {
    "adjust": "Aanpassen",
    "cancel": "Annuleren",
    "clear_recent": "Alle recente items en tours verwijderen",
    "delete": "Verwijderen",
    "discard": "Niet opslaan",
    "duplicate": "Dupliceren",
    "link": "Koppelen",
    "readspeaker": {
      "aria_label": "Voorlezen starten met Readspeaker"
    },
    "save": "Opslaan",
    "tootltip": {
      "results": {
        "show": "Bekijk resultaten"
      }
    }
  },
  "commercial": {
    "expression": {
      "button": {
        "link_boteacher": "https://thiememeulenhoff.crowdtech.com/landingspagina/",
        "link_demoinfo": "https://edition.thiememeulenhoff.nl/secure/next/demo",
        "name_boteacher": "Praat mee.",
        "name_demoinfo": "Meer informatie over de demo-groep"
      },
      "image": "/assets/commercialExpression.png",
      "image_bostudent": "/assets/commercialExpression.png",
      "image_boteacher": "https://cdn.tham.thiememeulenhoff.nl/document-output/tham.prod.563585db-d0fa-41da-8e6c-82070fd291c3/originaldocument",
      "image_demoinfo": "/assets/commercialExpression.png",
      "image_demoteacher": "/assets/commercialExpression.png",
      "image_vostudent": "/assets/commercialExpression.png",
      "image_voteacher": "https://cdn.tham.thiememeulenhoff.nl/document-output/tham.prod.c29db243-6510-4e6b-af33-32893b6b54fc/originaldocument",
      "subtitle": "Hier vind je al het benodigde leerling- en docentmateriaal op één plek. Heb je hulp nodig? Via het menu rechts bovenin vind je handige tools om wegwijs te worden in de online omgeving, zoals de digitale rondleiding, de compacte handleiding of de instructievideo's per onderdeel.",
      "subtitle_bostudent": "Hier vind je alles wat je nodig hebt op één plek. Van bronnen tot opdrachten en van theorie tot diagnostische toetsen. Veel plezier met het lesmateriaal!",
      "subtitle_boteacher": "Het onderwijs staat nooit stil, en dat vraagt om een nauwe samenwerking tussen de lesmethode en de lespraktijk. Jij weet namelijk als geen ander wat er echt speelt in de klas. Jouw praktijkervaring is dan ook onmisbaar voor de toekomst van jouw vak.\nDaarom nodigen we je uit voor de nieuwe ThiemeMeulenhoff Community. Een plek waar we met elkaar in gesprek gaan, ervaringen uitwisselen en samen nieuwe ontwikkelingen aanscherpen zodat ze nog beter aansluiten op jouw dagelijkse praktijk.",
      "subtitle_demoinfo": "Je kunt nu gebruik maken van eDition, het online leerplatform van ThiemeMeulenhoff.<br/>\n<br/>\nOm de mogelijkheden van eDition goed te kunnen bekijken, kun je een demo-groep aan je account koppelen. De demo-groep bestaat uit 10 leerlingen/studenten die al resultaten behaald hebben in een aantal vakken.",
      "subtitle_demoteacher": "Je kunt nu gebruik maken van eDition, het online leerplatform van ThiemeMeulenhoff.<br/>\n<br/>\nOm de mogelijkheden van eDition goed te kunnen bekijken, kun je een demo-groep aan je account koppelen. De demo-groep bestaat uit 10 leerlingen/studenten die al resultaten behaald hebben in een aantal vakken.<br/>\n<br/>\nAls je (nu) geen gebruik wilt maken van deze mogelijkheid, dan kan je ook direct door naar eDition om het online lesmateriaal en het bijbehorende docentmateriaal te bekijken. Als je later alsnog een demo-groep wilt aanmaken, dan kan dat altijd door deze pagina opnieuw te openen.",
      "subtitle_vostudent": "Hier vind je alles wat je nodig hebt op één plek. Van bronnen tot opdrachten en van theorie tot diagnostische toetsen. Veel plezier met het lesmateriaal!",
      "subtitle_voteacher": "Via de ToetsPers-knop in eDition bekijk je welke toetsen voor jouw methode beschikbaar zijn. Je kunt een toets direct gebruiken, aanpassen of zelf samenstellen. Mis je nog toetsen? Het aanbod wordt de komende tijd aangevuld.",
      "title": "Welkom in jouw digitale leeromgeving.",
      "title_bostudent": "Welkom in jouw digitale leeromgeving.",
      "title_boteacher": " Ga met collega-docenten in gesprek in onze online Community",
      "title_demoinfo": "Welkom in jouw digitale leeromgeving.",
      "title_demoteacher": "Welkom {{ userName }}!",
      "title_vostudent": "Welkom in jouw digitale leeromgeving.",
      "title_voteacher": "De eerste toetsen voor jouw methode vind je nu in ToetsPers!"
    }
  },
  "common": {
    "activation_code": "Activatiecode",
    "add": "Toevoegen",
    "back": "Terug",
    "back_to_top": "Terug naar boven",
    "change_email": "e-mailadres wijzigen",
    "confirm_password": "Bevestig wachtwoord",
    "create_account": "Account aanmaken",
    "email": "E-mailadres",
    "email_not_validated": "Je e-mailadres is nog niet bevestigd. Bekijk je inbox voor de bevestigingsmail of vraag een nieuwe aan.",
    "email_placeholder": "naam@email.com",
    "error_occurred": "Er is een onverwachte fout opgetreden",
    "favorites": "Favorieten",
    "field_required": "Dit veld is verplicht",
    "first_name": "Voornaam",
    "first_name_required": "Voornaam is verplicht.",
    "forgot_password": "Wachtwoord vergeten",
    "forgot_password_question": "Wachtwoord vergeten?",
    "invalid_email": "Dit is geen geldig e-mailadres.",
    "last_name_required": "Achternaam is verplicht.",
    "loading": "De data wordt ingeladen...",
    "login": "Inloggen",
    "logout": "Uitloggen",
    "method": "Methode",
    "modal": {
      "do_not_show_again": "Laat dit bericht niet meer zien"
    },
    "module": "Module",
    "new": "Nieuw",
    "next": "Volgende",
    "no_search_result": "Geen resultaten gevonden voor <b>'{{ query }}'</b>. Probeer een ander zoekwoord voor nieuwe resultaten.",
    "no_search_result_title": "Geen resultaten",
    "number_results": "{{count}} resultaten",
    "password": "Wachtwoord",
    "password_missing_lowercase": "Het wachtwoord moet minimaal één kleine letter bevatten.",
    "password_missing_number": "Het wachtwoord moet minimaal één cijfer bevatten.",
    "password_missing_special_character": "Het wachtwoord moet minimaal één speciaal teken bevatten (!@#$%^&*()?><€=_+-).",
    "password_missing_uppercase": "Het wachtwoord moet minimaal één hoofdletter bevatten.",
    "password_too_short": "Het wachtwoord moet minimaal 9 tekens bevatten.",
    "passwords_do_not_match": "Wachtwoorden komen niet overeen",
    "recent": "Recent",
    "reference_book": "Basisboek",
    "repeat_password": "Herhaal wachtwoord",
    "reset_password": "Wachtwoord herstellen",
    "result-toggle": {
      "bo": "Studentresultaten",
      "default": "Leerlingresultaten",
      "vo": "Leerlingresultaten"
    },
    "search": "Typ om te zoeken...",
    "search_and_filter": "Zoeken & filteren",
    "show_less": "Toon minder",
    "show_more": "Toon meer",
    "side-panel": {
      "aria-label": {
        "close": "Sluit paneel",
        "collapse": "Paneel inklappen",
        "expand": "Paneel uitklappen",
        "open": "Open paneel"
      }
    },
    "student": "Leerling",
    "student_type": {
      "bo": "studenten",
      "vo": "leerlingen"
    },
    "surname": "Achternaam",
    "surname_prefix": "Tussenvoegsel",
    "surname_prefix_label": "Tussenvoegsel",
    "table_of_contents": "Inhoudsopgave",
    "teacher": "Docent",
    "toegang_account_already_validated": "Deze activatielink is al gebruikt. Je account is waarschijnlijk al geactiveerd — log in met je e-mailadres en wachtwoord.",
    "toegang_error_unknown": "Er is iets misgegaan bij het inloggen. Probeer het later opnieuw.",
    "toegang_invalid_token": "De aanmeldsessie is ongeldig. Probeer opnieuw in te loggen.",
    "toegang_rate_limited": "Er is zojuist al een e-mail naar dit adres gestuurd. Wacht een paar minuten en probeer het opnieuw.",
    "toegang_token_expired": "De aanmeldsessie is verlopen. Probeer opnieuw in te loggen.",
    "toegang_user_not_found": "Geen account gevonden voor deze Toegang-gebruiker.",
    "toggle": {
      "bo": "Student",
      "bo (Copy)": "Student",
      "default": "Leerling",
      "vo": "Leerling"
    }
  },
  "content": {
    "breadcrumbs": {
      "aria_label": "breadcrumbs",
      "index": "Inhoudsopgave"
    },
    "embed": {
      "button_closed": "Lees meer",
      "button_open": "Lees minder"
    },
    "figure": {
      "fallback-label": "Bron {{addition}}"
    },
    "frame": {
      "label": {
        "case": "Casus",
        "context": "Context",
        "dialogue": "Gesprek",
        "example": "Voorbeeld",
        "explanation": "Uitleg",
        "summary": "Samenvatting"
      }
    },
    "interactions": {
      "drawing_canvas": {
        "actions": {
          "clear": "Alles wissen"
        }
      },
      "feedback": {
        "correct": {
          "label": "Je antwoord is goed."
        },
        "incorrect": {
          "label": "Je antwoord is niet goed.",
          "sublabel": "Neem het volgende mee om je antwoord te verbeteren:"
        }
      },
      "model_answer": "Modelantwoord",
      "self_score": {
        "open_text": {
          "title": "Kijk je antwoord zelf na:"
        },
        "rubric_group": {
          "weight": "Bepaalt {{weight}}% van totaalscore"
        },
        "rubric": {
          "completed": "Deze totaalscore gaf je jezelf voor deze opdracht.",
          "explanation": "Score is opgebouwd uit de volgende onderdelen:",
          "next_group": "Volgende beoordeling",
          "prev_group": "Vorige beoordeling",
          "title": "Kijk je antwoord zelf na en kies een passende score:"
        },
        "scale": {
          "explanation": "Deze score gaf jij aan jouw antwoord:",
          "title": "Hoe goed klopt jouw antwoord?"
        }
      },
      "speaking": {
        "action_listen": {
          "error": "Voorbeeld opvragen mislukt, klik om het opnieuw te proberen.",
          "label": "Luisteren"
        },
        "action_play": {
          "error": "Opname opvragen mislukt, klik om het opnieuw te proberen.",
          "instruction": "Opname",
          "label": "Afspelen"
        },
        "action_record": {
          "instruction": "Ingedrukt houden",
          "label": "Opnemen"
        },
        "action": {
          "error": {
            "label": "Er is iets fout gegaan."
          }
        },
        "mic_unavailable": {
          "label": "Je microfoon lijkt niet beschikbaar te zijn of je hebt ons geen toegang gegeven tot je microfoon.",
          "tooltip": "Klik hier om het activeren van je microfoon opnieuw te proberen."
        },
        "score": {
          "excellent": "Goed gedaan!",
          "poor": "Dit kan beter. Luister nog eens goed naar de woorden met een stippellijn eronder.",
          "satisfactory": "Bijna goed, probeer het nog een keer!",
          "unsatisfactory": "Goede poging, maar het kan beter. Luister nog eens goed naar de woorden met een stippellijn eronder."
        }
      },
      "upload": {
        "drop_dragging_file": "Laat je afbeelding los om te uploaden",
        "drop_file": "Upload een afbeelding",
        "dropped_file": "Je bestand is geüpload!",
        "placeholder": "Sleep een afbeelding hierheen of selecteer een afbeelding",
        "select_file": "Selecteer afbeelding",
        "uploading": "Afbeelding uploaden..."
      },
      "validators": {
        "matrix_max": "Je hebt het maximaal aantal antwoorden overschreden.",
        "matrix_min": "De minimale waarde is {{min}}",
        "max": "Je hebt het maximaal aantal antwoorden overschreden.",
        "min": "De minimale waarde is {{min}}",
        "must-contain": "Je antwoord moet \"{{mustContain}}\" bevatten",
        "required": "Je moet een antwoord opgeven"
      },
      "your_answer": "Jouw antwoord"
    },
    "quote": {
      "author": {
        "title": "Auteur van de quote"
      }
    },
    "remark": {
      "label": {
        "attention": "Let op!",
        "hint": "Hint",
        "tip": "Tip"
      }
    },
    "score-label": {
      "completed": "Opdracht gedaan"
    }
  },
  "custom-content": {
    "arrangements": {
      "description": "Arrangementen blijven aanpasbaar. Gedeelde wijzigingen zijn zichtbaar voor de gekoppelde groep."
    },
    "create": {
      "reader": {
        "modal": {
          "create_arrangement_button": "Nieuw arrangement maken",
          "create_button": "Reader maken",
          "created_at": "Aangemaakt op {{ date }}",
          "existing_readers": "Heeft al {{ count }} readers",
          "header": "Nieuwe reader maken",
          "no_arrangements": {
            "text": "Maak eerst een arrangement voordat je een reader kunt maken.",
            "title": "Geen arrangementen beschikbaar"
          },
          "subtitle": "Kies het arrangement waarop je de reader wilt baseren."
        }
      }
    },
    "description": "Stel lesmateriaal samen, maak printklare readers en bundel ze in bestelsets.",
    "header": "TM op maat",
    "modal_archive": {
      "description": "Deze reader is daarna niet meer beschikbaar via de bestellink. Bestaande bestellingen blijven ongewijzigd.",
      "submit": "Reader intrekken",
      "title": "Reader intrekken?"
    },
    "modal_delete": {
      "description": "Weet je zeker dat je \"{{title}}\" definitief wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      "submit": "Verwijderen",
      "title": "Reader verwijderen?"
    },
    "modal_publish": {
      "description": "<p>We maken een printklare reader van de huidige stand van je arrangement. Je krijgt een melding zodra de bestellink beschikbaar is.</p><p>Latere wijzigingen in jet arrangement worden niet automatich verwerkt in deze reader.</p>",
      "submit": "Bestelbaar maken",
      "title": "Reader bestelbaar maken?"
    },
    "modal_recover": {
      "description": "Deze reader wordt opnieuw klaargezet voor de webshop. Dit duurt meestal 1-2 minuten. Daarna is de bestellink weer actief.",
      "submit": "Opnieuw bestelbaar maken",
      "title": "Reader opnieuw bestelbaar maken?"
    },
    "reader": {
      "preview": {
        "back-to-readers": "Terug naar readers",
        "created-at": "Aangemaakt op",
        "description": "Omschrijving",
        "disclaimer": {
          "draft": "Deze reader wordt automatisch klaargezet zodra de huidige verwerking klaar is.",
          "failed": "Deze reader kon niet succesvol worden verwerkt. Neem contact op met support om dit probleem op te lossen.",
          "processed": "Deze reader is bestelbaar. Latere wijzigingen in het arrangement worden niet automatisch verwerkt in deze reader.",
          "ready": "Deze reader is bestelbaar. Latere wijzigingen in het arrangement worden niet automatisch verwerkt in deze reader."
        },
        "edit": "Bewerken",
        "info": {
          "archived": "Deze reader is niet meer beschikbaar via de bestellink. Je kunt de reader op elk moment opnieuw bestelbaar maken.",
          "generated": "Deze reader is opgeslagen, maar nog niet bestelbaar.",
          "processing": "De reader wordt klaargezet voor de webshop. Je krijgt een melding zodra de bestellink beschikbaar is."
        },
        "loading": "Laden...",
        "no-description": "Geen omschrijving",
        "no-pages": "Wordt berekend...",
        "no-pdf": "De reader wordt automatisch gegenereerd. Dit kan een paar minuten duren...",
        "no-school": "Geen school",
        "no-sub-title": "Geen ondertitel",
        "page-count-warning": {
          "max": "Maximaal 640 pagina's.",
          "min": "Minimaal 60 pagina's."
        },
        "pages": "Pagina's",
        "pdf-view-error": {
          "action": "Contact opnemen",
          "description": "Deze reader kon niet succesvol worden gegenereerd. Neem contact op met\n        support om dit probleem op te lossen.",
          "title": "Er is iets misgegaan met deze reader"
        },
        "publishing": {
          "description": "{{ title }} - Reader wordt klaargezet voor de webshop. Dit duurt meestal 1-2 minuten.",
          "title": "Reader wordt klaargezet",
          "view": "Bekijken"
        },
        "reader-information": "Reader informatie",
        "reader-webshop": "Reader / webshop",
        "readertype": "Readertype",
        "school-name": "Schoolnaam",
        "sub-title": "Ondertitel",
        "title": "Titel",
        "warning": {
          "change-arrangement": "Arrangement aanpassen",
          "too-few-pages": {
            "message": "Een reader moet minimaal 60 pagina's bevatten om bestelbaar te maken. Voeg meer materiaal toe aan het arrangement.",
            "title": "Reader is te klein"
          },
          "too-many-pages": {
            "message": "Deze reader heeft meer dan 640 pagina's en kan daarom niet bestelbaar worden gemaakt. Maak het arrangement kleiner om het aantal pagina's te verminderen. Wil je de inhoud behouden? Maak dan vanuit het arrangement twee aparte readers: een Theorieboek en een Werkboek.",
            "title": "Reader is te groot"
          }
        }
      }
    },
    "readers": {
      "action": {
        "toaster": {
          "copy_store_link": "Bestellink gekopieerd"
        }
      },
      "card": {
        "action": {
          "archive": "Reader intrekken",
          "copy_store_link": "Bestellink kopiëren",
          "delete": "Reader verwijderen",
          "edit": "Readergegevens wijzigen",
          "open_store": "Open webshop",
          "view": "Reader bekijken"
        },
        "status": {
          "draft": "Concept",
          "failed": "Fout",
          "generated": "Gegenereerd",
          "generating": "Genereren",
          "processing": "Wordt klaargezet",
          "ready": "Bestelbaar"
        },
        "subtitle": "Aangemaakt op {{ date }}"
      },
      "choose_arrangement": "Kies een arrangement als bron.",
      "create_new": "Nieuwe reader",
      "description": "Een reader is een printklare versie van een arrangement. Bestelbare readers krijgen een bestellink voor de webshop.",
      "preview": {
        "action": {
          "archive": "Reader intrekken",
          "copy": "Kopiëren",
          "open_store": "Open webshop",
          "recover": "Opnieuw bestelbaar maken"
        },
        "store_url": "Bestellink"
      }
    },
    "toggle": {
      "arrangements": "Arrangementen",
      "readers": "Readers"
    }
  },
  "edu-admin": {
    "admin": {
      "header": {
        "api_docs": "API-documentatie",
        "readers_page": "Readers",
        "title": "Edu Admin",
        "user_page": "Gebruikersinformatie"
      }
    },
    "docs": {
      "apis": {
        "vesta": {
          "description": "API voor het beheer van streams, arrangements, clusters, content en methodes.",
          "title": "Vesta"
        }
      },
      "error": {
        "loading": "Er is een onverwachte fout opgetreden bij het ophalen van platforms.",
        "swagger": "Er is een onverwachte fout opgetreden bij het ophalen van de API-documentatie."
      },
      "info": {
        "no-platforms": "Er zijn geen platforms beschikbaar."
      },
      "overview": {
        "open": "Documentatie openen"
      },
      "platform": {
        "loading": "Platforms laden...",
        "title": "OAuth-platform"
      },
      "shell": {
        "intro": "Overzicht van beschikbare API-documentatie.",
        "overview": "Overzicht",
        "title": "API-documentatie"
      }
    },
    "errorpage": {
      "403": {
        "description": "Het lijkt erop dat je geen toegang hebt tot de inhoud van deze pagina. Dat kan komen omdat het geen onderdeel is van jouw licentie."
      }
    },
    "header": {
      "methods_page": "Methodes",
      "user-page": "Gebruikersinformatie"
    },
    "methods": {
      "actions": "Acties",
      "arrangeable": "Arrangeerbaar",
      "edit_action": "Bewerk",
      "language": "Taal",
      "level": "Niveau",
      "name": "Naam",
      "not_arrangeable": "Niet arrangeerbaar",
      "results": "{{ filtered }} van {{ total }} gevonden.",
      "search-label": "Zoek methodes",
      "search-placeholder": "Zoek naar methode",
      "slug": "Slug",
      "subject": "Vak",
      "view_action": "Bekijk",
      "view_arrangement_action": "Arrangementen"
    },
    "readers": {
      "actor": "Actor",
      "arrangement-code": "Arrangement code",
      "back-to-readers": "Terug naar readers",
      "content-identifier": "Content identifier",
      "created-at": "Gemaakt op",
      "description": "Omschrijving",
      "external-id": "External ID (reference)",
      "id": "ID",
      "method-code": "Methode code",
      "method-ean": "Methode EAN",
      "no-results": "Geen readers gevonden voor {{ query }}",
      "open-pdf": "Open PDF",
      "page-count": "Aantal pagina's",
      "reader-not-found": "Reader niet gevonden.",
      "reader-type": "Reader type",
      "reference": "Reference",
      "results": "{{ filtered }} van {{ total }} gevonden.",
      "school-name": "Schoolnaam",
      "search-label": "Zoek readers",
      "search-placeholder": "Zoek naar reader",
      "status": "Status",
      "store-url": "Winkel URL",
      "title": "Titel",
      "updated-at": "Aangepast op"
    },
    "ui": {
      "breadcrumbing": {
        "results": "Resultaten in {{ streamCode }}",
        "streams": "Streams van {{ userId }}"
      },
      "deletion-popup": {
        "body": "{{ title }} is verwijderd.",
        "title": "Resultaat verwijderd"
      },
      "loader": "Dit kan enkele minuten duren...",
      "user-id": {
        "placeholder": "Bijvoorbeeld: a0b1c2d3e4f5g6h7a0b1c2d3e4f5g6h7"
      }
    },
    "users": {
      "detached_results": {
        "notice": "Let op, deze gebruiker heeft {{ count }} ontkoppelde antwoorden in de database staan. Deze horen bij vragen die niet meer voorkomen in de huidige stream. Deze antwoorden zijn in een vorige versie van de stream gemaakt en worden bijvoorbeeld niet meer getoond bij de resultaten.",
        "table": {
          "content_path": "ContentPath",
          "created": "Created",
          "status": "Status"
        }
      },
      "export_data": {
        "csv": {
          "action": "Download als CSV",
          "description": "Gebruik dit bestand als je de gegevens wilt uitwisselen of importeren in een ander systeem."
        },
        "description": "Download de gegevens als een plain CSV-bestand.",
        "title": "Gegevens exporteren"
      },
      "merge_results": {
        "conflicts": {
          "table": {
            "arrangement_code": "ArrangementCode",
            "content_identifier": "ContentIdentifier",
            "content_path": "ContentPath",
            "status": "Status",
            "type": "Type"
          },
          "toggle_hide": "Verberg conflicten",
          "toggle_show": "Bekijk conflicten",
          "warning": "Er zijn conflicterende resultaten tussen deze gebruikers. Deze resultaten worden niet overgezet. Dit gedrag bestond ook al in de vorige Edu-Admin omgeving.<br />(Niet conflicterende resultaten zullen wel overgezet worden)"
        },
        "heading": "Resultaten verplaatsen:",
        "no_results": "Deze gebruiker heeft geen resultaten.",
        "source_heading": "Te verplaatsen resultaten van {{ sourceUser }} naar {{ targetUser }}:",
        "submit": "Verplaatsen",
        "table": {
          "method": "Methode",
          "questions": "Vragen",
          "stream": "Stream",
          "stream_code": "Streamcode",
          "tests": "Toetsen"
        },
        "target_heading": "Huidige resultaten van {{ user }}",
        "target_streamcode_suffix": "voor streamcode {{ arrangement }}"
      },
      "results_status_legend": {
        "result_statuses": {
          "heading": "Result Statussen",
          "items": {
            "archived": {
              "description": "Resultaat is verwijderd/gereset.",
              "label": "archived"
            },
            "checked": {
              "description": "Antwoord nagekeken, feedback/score beschikbaar.",
              "label": "checked"
            },
            "completed": {
              "description": "Alles afgerond, opdracht is klaar.",
              "label": "completed"
            },
            "draft_retry": {
              "description": "Draft van een retry (opnieuw proberen), nog niet verzonden.",
              "label": "draft_retry"
            },
            "draft": {
              "description": "Iets ingevuld en automatisch opgeslagen, nog niet verzonden.",
              "label": "draft"
            },
            "empty": {
              "description": "Niks gebeurd, leeg.",
              "label": "empty"
            },
            "processing_selfscore": {
              "description": "Zelfscore wordt verwerkt.",
              "label": "processing_selfscore"
            },
            "processing": {
              "description": "Bezig met berekeningen.",
              "label": "processing"
            },
            "submitted": {
              "description": "Antwoord is ingediend/opgestuurd.",
              "label": "submitted"
            },
            "waiting_for_selfscore": {
              "description": "Leerling moet nog een zelfscore geven.",
              "label": "waiting_for_selfscore"
            }
          }
        },
        "sequence_statuses": {
          "heading": "Sequence Statussen",
          "items": {
            "completed": {
              "description": "Nagekeken, alles voltooid.",
              "label": "completed"
            },
            "not_started": {
              "description": "Nog niets gedaan met de zelftoets.",
              "label": "not_started"
            },
            "processing_completed": {
              "description": "Afronding wordt verwerkt.",
              "label": "processing_completed"
            },
            "processing_submitted": {
              "description": "Inzending wordt verwerkt.",
              "label": "processing_submitted"
            },
            "started": {
              "description": "Zelftoets gestart (intro gezien).",
              "label": "started"
            },
            "submitted": {
              "description": "Ingezonden, nog niet nagekeken/beschikbaar.",
              "label": "submitted"
            }
          }
        },
        "title": "Status Legenda",
        "trigger": "Legenda"
      },
      "search": {
        "alert_explanation": "Mogelijke meldingen",
        "detached_users_note": "Binnen eDition zijn 'oude' gebruikers (die in de Profielmigratie voorkwamen) nog steeds bekend onder hun TM Profile ID zolang ze niet via een User Merge of migratie samengevoegd zijn. Deze tool zal aangeven wanneer een Pseudo ID <em>binnen eDition</em> een TM Profile ID kent.",
        "heading": "Gebruiker opzoeken",
        "intro": "Via deze tool kan je gebruikers binnen eDition opzoeken en hun resultaten raadplegen.",
        "post_merge_note": "Nadat een User Merge is uitgevoerd, zal deze tool geen resultaten meer tonen onder het TM Profile ID. Als je zoekt op het Pseudo ID zal er ook géén melding getoond meer worden van een gevonden TM Profile ID.",
        "results": {
          "no-user": "De gebruiker kan niet worden ingeladen omdat deze niet bestaat.",
          "warning": "Er zijn geen resultaten gevonden voor {{actor}}."
        },
        "statistic_warnings": "Op deze pagina kunnen verschillende meldingen worden getoond, afhankelijk van de situatie:<ul><li>Wanneer een gebruiker <b>wel</b> bestaat maar geen resultaten heeft, wordt een <b>informatieve melding</b> getoond dat er geen resultaten zijn gevonden voor deze gebruiker.</li><li>Wanneer de gebruiker <b>niet</b> bestaat, wordt een <b>waarschuwingsmelding</b> getoond. </li><li>Tijdens het samenvoegen van gebruikers kan een <b>informatieve melding</b> verschijnen als de doelgebruiker nog geen resultaten heeft.</li><li>Tijdens het samenvoegen van gebruikers kan daarnaast een <b>waarschuwingsmelding</b> verschijnen als er conflicten zijn gevonden in de resultaten die extra controle vereisen.</li></ul>",
        "stream_results": {
          "warning": "Er zijn geen resultaten gevonden voor {{actor}} in {{streamCode}}."
        },
        "submit": "Opzoeken",
        "user_id_label": "Gebruikers ID"
      },
      "stream_results": {
        "attempt_table": {
          "created": "Created",
          "json_data": "JSON Data",
          "number": "Nummer",
          "score": "Score",
          "status": "Status",
          "thip_id": "ThipId",
          "title": "Titel"
        },
        "delete_confirm_button": "Bevestigen",
        "delete_confirm_title": "Weet je zeker dat je het antwoord voor vraag '{{ name }}' wilt verwijderen? Dit kan niet hersteld worden!",
        "delete_question": "Verwijder de vraag '{{title}}'",
        "delete_sequence": "Verwijder gehele zelftoets",
        "description": "Overzicht van streamcode <strong>{{ streamCode }}</strong> voor gebruiker <strong>{{ userId }}</strong>.",
        "detached_heading": "Ontkoppelde resultaten",
        "heading": "Resultaten in {{ method }} - {{ streamName }}",
        "not_found": "Deze gebruikersdata kan niet worden ingeladen om een van de volgende redenen:\n\n<ul>\n  <li>De stream bestaat niet</li>\n  <li>Je hebt geen toegang tot de stream</li>\n</ul>",
        "question_result": {
          "score_label": "Score"
        },
        "search": {
          "empty": "Er zijn geen resultaten gevonden voor de zoekopdracht: <strong>'{{ query }}'</strong> binnen deze pagina.",
          "label": "Zoek in resultaten",
          "placeholder": "Zoek op titel, ThipId, status of content"
        },
        "toc": {
          "module_label": "Module {{ resourceNumber }}"
        },
        "toggle_all_close": "Sluit alles",
        "toggle_all_open": "Alle hoofdstukken openen",
        "toggle_show_empty_resources": "Toon lege resources"
      },
      "stream": {
        "all_streams_option": "Alle streams verplaatsen",
        "choose_stream_code": "Selecteer een stream code",
        "heading": "Nieuwe gebruiker opzoeken",
        "merge_description": "Verplaats de resultaten binnen een of alle streams van gebruiker {{ actor }} naar een gewilde doelgebruiker.",
        "merge_heading": "Resultaten verplaatsen",
        "no_statistics": "Geen statistieken gevonden.",
        "search": {
          "empty": "Er zijn geen resultaten gevonden voor de zoekopdracht: <strong>'{{ query }}'</strong>.",
          "label": "Zoek in streams",
          "placeholder": "Zoek op methode, stream of streamcode"
        },
        "stream_code_label": "Stream code",
        "stream_code_placeholder": "Kies een stream of houd dit veld leeg om alles over te zetten",
        "streams_heading": "Streams van {{ actor }}",
        "submit": "Controleren",
        "table": {
          "method": "Methode",
          "questions": "Vragen",
          "stream": "Stream",
          "stream_code": "StreamCode",
          "tests": "Toetsen",
          "view_results": "Bekijk Resultaten"
        },
        "target_user_id_label": "Gebruikers ID"
      }
    }
  },
  "error": {
    "403": {
      "call_to_action": "Om je licentie te upgraden, of een licentie te activeren, bezoek je één van de volgende pagina's:",
      "message": "De pagina die je hebt opgevraagd maakt helaas geen deel uit van je licentie.",
      "title": "Content niet beschikbaar"
    },
    "404": {
      "message": "De gevraagde pagina is niet gevonden."
    },
    "5xx": {
      "message": "Er heeft zich een systeemfout voorgedaan. Indien mogelijk, klik op de onderstaande knop om het laden opnieuw te proberen of bekijk het overzicht van actuele storingen.",
      "retry": "Opnieuw proberen"
    },
    "base": {
      "general_information": "<p>\n  <a href=\"https://status.thiememeulenhoff.nl/\" target=\"_blank\">Bekijk het overzicht van storingen en onderhoud</a>.\n</p>\n\n<p>\n  Bezoek één van de onderstaande pagina's om de informatie die je zoekt te vinden:\n  \n  <ul>\n    <li>\n      <a href=\"https://mijn.thiememeulenhoff.nl/\" title=\"Mijn ThiemeMeulenhoff\">Mijn ThiemeMeulenhoff</a>\n    </li>\n    <li>\n      <a href=\"https://www.thiememeulenhoff.nl?utm_source=edition&utm_medium=referral&utm_content=error_pagina\" title=\"ThiemeMeulenhoff.nl\">ThiemeMeulenhoff.nl</a>\n    </li>\n  </ul>\n</p>",
      "message": "Er is een fout opgetreden.",
      "method_questions": "<p>Heb je vragen over ThiemeMeulenhoff of onze lesmethoden? Neem dan contact op met <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\"> de afdeling Klantenservice</a>.</p>",
      "title": "Oeps..."
    }
  },
  "errorpage": {
    "403": {
      "action": "<a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">Contacteer de klantenservice</a> om je licenties te regelen",
      "description": "Het lijkt erop dat je geen toegang hebt tot de inhoud van deze pagina. Dat kan komen omdat het geen onderdeel is van jouw licentie.\n\n<ol>\n<li>Bekijk al je actieve licenties op je homepage</li>\n<li>Of neem contact op met de klantenservice om je licenties te regelen</li>\n</ol>\n",
      "title": "Content niet beschikbaar"
    },
    "404": {
      "action": "Wanneer je denkt dat dit een fout is, kun je <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">contact opnemen met de klantenservice</a>",
      "description": "De pagina die je zoekt kunnen we helaas niet vinden. Deze pagina lijkt niet (meer) te bestaan. Mogelijk is de pagina verplaatst, verwijderd, of bevat de link een typfout.",
      "title": "Oeps, deze pagina bestaat niet"
    },
    "500": {
      "action": "In het overzicht van <a href=\"https://status.thiememeulenhoff.nl/\" target=\"_blank\">storingen en onderhoud</a> kun je zien of er een bekend probleem is. Lukt het later nog niet, <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">contact dan de klantenservice</a>.",
      "description": "Er is een technisch probleem waardoor we de pagina even niet kunnen tonen. <br /><br />\n\nDit probleem kan meerdere oorzaken hebben. Probeer het later nog eens of keer terug naar de homepage. ",
      "title": "Er is iets misgegaan"
    },
    "arrangement": "Naar arrangementenoverzicht",
    "home": "Naar homepage",
    "loading": {
      "action": "Blijft het probleem bestaan? Neem dan <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">contact op met de klantenservice</a>",
      "description": "We laden je pagina, maar het gaat langzamer dan normaal. Nog even geduld of probeer het opnieuw. Blijft het lang duren, controleer dan je internetverbinding.",
      "title": "Het laden duurt langer dan verwacht"
    },
    "refresh": "Ververs pagina",
    "screensize-results": {
      "action": "Kom je er niet uit? <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">Neem contact op met de klantenservice</a>",
      "description": "Om resultaten te bekijken heb je meer werkruimte nodig. Dit kun je op drie manieren oplossen\n<br />\n\n<ul>\n<li>Zoom uit in je browser</li>\n<li>Gebruik laptop of desktop met een groter scherm</li>\n<li>Draai je tablet horizontaal</li>\n</ul>\n",
      "title": "Dit scherm is te klein"
    },
    "screensize": {
      "action": "Kom je er niet uit? <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">Neem contact op met de klantenservice</a>",
      "description": "Om lesmateriaal te bewerken heb je meer werkruimte nodig. Dit kun je op drie manieren oplossen:\n<br />\n\n<ul>\n<li>Zoom uit in je browser</li>\n<li>Gebruik laptop of desktop met een groter scherm</li>\n<li>Draai je tablet horizontaal</li>\n</ul>\n\n<br />\nJe kunt wel het overzicht van arrangementen bekijken.",
      "title": "Dit scherm is te klein"
    }
  },
  "external-link-card": {
    "community": {
      "link": "https://thiememeulenhoff.crowdtech.com/landingspagina/",
      "subject": "Verbind met collega's, wissel ervaringen uit en haal inspiratie uit de community.",
      "title": "ThiemeMeulenhoff Community"
    },
    "toetspers": {
      "subject": "Maak en beheer toetsen in de toetsomgeving.",
      "title": "Toetsen",
      "via": "via ToetsPers"
    }
  },
  "feedback": {
    "placeholder": {
      "empty": "Geef feedback",
      "filled": "Geef feedback"
    },
    "prefix-time": "om",
    "teacher": {
      "intro": {
        "bo": "Bericht voor de student",
        "default": "Bericht voor de leerling",
        "vo": "Bericht voor de leerling"
      }
    },
    "title": "Feedback"
  },
  "filters": {
    "learningMetadata": {
      "cefrQualifications": "ERK-niveau",
      "language": "Taal",
      "learningLevels": "Leerniveau",
      "referenceLevel": "Referentieniveau",
      "workingMethod": "Werkvorm"
    },
    "navigationMetadata": {
      "number": "Taak"
    },
    "smartMetadata": {
      "continents": "Werelddeel",
      "geographyTypes": "Type geografie",
      "keywords": "Trefwoorden",
      "learningGoals": "Leerdoel",
      "mboCourseStructure": "Opbouw kwalificatiedossier",
      "mboDoorEngels": "Thema",
      "mboDoorNederlands": "Thema",
      "mboProfile": "Profiel",
      "mboQualifications": "Kwalificatiedossier",
      "mboSubjectArea": "Vakgebied",
      "mboTechnical": "Domein",
      "mboTouchTech": "Vakgebied",
      "mboWorkProcesses": "Kerntaak en werkproces",
      "musicDifficulty": "Muziekmoeilijkheidsgraad",
      "musicStyles": "Trefwoord",
      "rhvClassifications": "Differentiatie",
      "themes": "Thema's"
    },
    "streamMetadata": {
      "schoolYears": "Leerjaar"
    }
  },
  "focus": {
    "detail": {
      "no-results": {
        "subtitle": {
          "bo": "Deze student heeft nog geen poging gedaan voor deze opdracht, of het resultaat is gewist.",
          "default": "Deze leerling heeft nog geen poging gedaan voor deze opdracht, of het resultaat is gewist.",
          "vo": "Deze leerling heeft nog geen poging gedaan voor deze opdracht, of het resultaat is gewist."
        },
        "title": "Nog geen resultaat"
      }
    }
  },
  "footer": {
    "copyright": "Copyright",
    "disclaimer": "Disclaimer",
    "next": "Volgende",
    "previous": "Vorige",
    "privacy-policy": "Privacy",
    "terms-and-conditions": "Algemene voorwaarden"
  },
  "general": {
    "action": {
      "close": "sluiten"
    },
    "favorite": {
      "add": "Voeg toe aan favorieten",
      "remove": "Verwijder uit favorieten"
    },
    "instructor": {
      "assets": {
        "download": "Download alles uit  '{{ noun }}'",
        "download_filtered": "Download deze {{ noun }}"
      },
      "link": {
        "toets_pers": "Ga naar toetsomgeving"
      }
    },
    "open": "Open"
  },
  "glue_content": {
    "collapse": "Inklappen",
    "expand": "Lees verder"
  },
  "group": {
    "code": {
      "alert": {
        "subscribed": "Je bent succesvol aangemeld bij de groep.",
        "wrong": "De groepscode is onjuist. Probeer het opnieuw."
      },
      "button_submit": "Aanmelden bij de groep",
      "title": "Groepscode invoeren"
    },
    "manage": {
      "title": "Groepenbeheer"
    }
  },
  "header": {
    "aria-label": {
      "navigate": {
        "back": "Sluit en ga terug",
        "home-page": "Link naar de homepage"
      }
    },
    "assignmentcount": "Opdracht {{index}} van {{total}}"
  },
  "label": {
    "assignments": "Opdrachten",
    "correct_answer": "Goede antwoord",
    "my_answer": "Mijn antwoord",
    "remove": "Verwijderen",
    "theory": "Theorie"
  },
  "landing": {
    "adjust_preference": "Pas hier je voorkeuren aan",
    "all_teaching_materials": "Al het lesmateriaal",
    "arrangement": {
      "button_header": "Inhoud arrangeren",
      "button_text": "Stel je eigen lesmateriaal samen. Zo heb je altijd lesmateriaal dat aansluit bij de les die jij wil geven.",
      "button_text_short": "Stel je eigen lesmateriaal samen",
      "deeplink_button": "Ga naar {{ arrangementTitle }}",
      "favorites": {
        "toaster": {
          "add": "Arrangement '{{ title }}' is toegevoegd aan je favorieten.",
          "remove": "Arrangement '{{ title }}' is verwijderd uit je favorieten."
        }
      },
      "info": {
        "custom_arrangements": "Samengesteld lesmateriaal wordt automatisch een favoriet.",
        "favorite_arrangements": "Voeg favorieten toe met het bookmark-icoon.",
        "header_favorite": "Je favoriete lesmateriaal verschijnt hier.",
        "header_recent": "Je recente lesmateriaal verschijnt hier.",
        "recent_arrangements": "Alles wat je recent hebt gebruikt, houden we voor je bij."
      }
    },
    "demo": {
      "button_demogroup": "Geef mij een demo-groep!",
      "button_edition": "Ga naar eDition",
      "demogroup_info": "De demo-groep genaamd \"Demogroep\" is gekoppeld aan je account. Je kunt nu door naar eDition. In de volgende arrangementen kan je de resultaten van leerlingen / studenten van deze groep bekijken:",
      "demogroup_info_bottom": "Via het groepenbeheer in het gebruikersmenu in eDition kan je de demo-groep op elk gewenst moment weer verwijderen uit je account."
    },
    "main": {
      "label_all_arrangements": "Alle leermiddelen",
      "label_continue": "Ga verder",
      "label_empty": "<h2>Welkom!</h2>\n<p>Het lijkt erop dat je nog geen toegang tot het online lesmateriaal hebt.</p>",
      "label_user_defined_arrangements": "Door je docent klaargezette leermiddelen"
    },
    "make_arrangement": "Arrangeren",
    "nudge_content": "Wat wil jij van jouw lesmateriaal als eerste op je scherm zien? Kies die voorkeur(en) via ‘Pas hier je voorkeur aan’. \n\nLet op: je kunt je keuze op elk moment aanpassen. En je houdt altijd toegang tot de rest van het bestelde lesmateriaal.",
    "nudge_title": "Je hebt nog geen voorkeur gekozen.",
    "preferred_teaching_materials": "Jouw voorkeurslesmateriaal",
    "preferred_teaching_materials_intro": "Als je voorkeurslesmateriaal hebt ingesteld, dan zie je hieronder eerst het lesmateriaal dat je als voorkeur hebt ingesteld. Daaronder staat de rest van het bestelde lesmateriaal. Je kunt je voorkeuren altijd aanpassen.",
    "setup_preference": "Voorkeurslesmateriaal kiezen",
    "view_all": "Alle leermiddelen",
    "welcome": "Welkom {{name}}!",
    "welcome_description": "Je hebt toegang tot onderstaande methodes. Ga naar het lesmateriaal dat jij nodig hebt. Met enkele klikken heb je direct toegang tot content die voor jou relevant is.",
    "welcome_no_licenses": "Je hebt nog geen actieve licenties.",
    "your_teaching_materials": "Jouw lesmateriaal"
  },
  "layout": {
    "header": {
      "arrangement": {
        "aria-label": "Ga naar {{ name }}",
        "image": "{{ name }} logo",
        "logo_alt": "{{name}} logo",
        "logo_aria_label": "Methodelogo"
      },
      "group": {
        "button_label_empty": "Selecteer een groep",
        "button_manage": "Groepenbeheer",
        "empty_label": "Je hebt nog geen groepen, maak een groep aan om je weergave te filteren op basis van een groep.",
        "las_groups_label": "Groepen",
        "own_groups_label": "Eigen groepen",
        "show_teacher_checkbox": "Toon docent(en) als onderdeel van geselecteerde groep",
        "title": "Filter je weergave op basis van een groep"
      },
      "materials": {
        "all": "Alle leermiddelen van {{method}}",
        "edit_preference": "Kies je voorkeurslesmateriaal",
        "preferred_materials": "Voorkeurslesmateriaal",
        "title": "Selecteer leermiddel"
      },
      "method": {
        "all_methods": "Alle methodes",
        "aria-label": "Ga naar {{ name }}",
        "image": "{{ name }} logo",
        "recent_methods": "Recent gebruikte methodes"
      },
      "notification": {
        "button_all_read": "Alles gelezen",
        "button_delete_all": "Alles verwijderen",
        "empty_description": "Geen meldingen aanwezig.",
        "title": "Jouw meldingen"
      },
      "search": {
        "button_filter": "Filteren",
        "button_search": "Zoeken",
        "button_sort": "Sorteren",
        "checkbox_search_within_method": "Zoek alles binnen {{method}}",
        "facet_glossentry": "Begrippen",
        "facet_source": "Bronnen",
        "facet_theory": "Theorie",
        "label_no_content": "Geen zoekresultaten op \"{{query}}\". Pas je zoekterm aan door bijvoorbeeld op maar één woord te zoeken",
        "query_placeholder": "Typ om te zoeken...",
        "searching": "Zoeken...",
        "title": "Zoeken naar theorie, begrippen en bronnen"
      },
      "teacher_options": {
        "button_arrange": "Inhoud arrangeren",
        "button_group_results": "Resultaten per groep",
        "button_results": {
          "bo": "Resultaten per student",
          "default": "Resultaten per leerling",
          "vo": "Resultaten per leerling"
        },
        "title": "Docentopties"
      },
      "user": {
        "button_add_demo_group": "Demogroep koppelen",
        "button_arrange": "Arrangeren",
        "button_colofon": "Colofon",
        "button_community_platform": "Community platform",
        "button_group_code": "Groepscode invoeren",
        "button_group_management": "Groepenbeheer",
        "button_group_subscribe": "Deelnemen",
        "button_instruction_videos": "Instructievideo’s leeromgeving",
        "button_manage_subscription": "Beheer abonnementen",
        "button_manual": "Handleiding leeromgeving",
        "button_my_licenses": "Mijn docentlicentie",
        "button_my_methods": "Mijn methodes",
        "button_my_nt2_licenses": "Mijn NT2-licenties",
        "button_sign_out": "Uitloggen",
        "button_teacher_environment": "Docentomgeving",
        "button_tour": "Rondleiding leeromgeving",
        "button-support-language": "Steuntaal",
        "group_code_already_subscribed": "Je bent al onderdeel van de ingegeven groepscode.",
        "group_code_not_found": "De ingegeven groepscode is onbekend. Probeer het opnieuw.",
        "group_code_unknown_error": "Er is een onverwachte fout opgetreden, probeer het later nog eens.",
        "group-subscribe-success": "Je bent toegevoegd aan groep: {{groupName}}",
        "label_student_mode": {
          "bo": "Studentweergave",
          "default": "Leerlingweergave",
          "vo": "Leerlingweergave"
        },
        "modal_student_mode": {
          "to_student_body": "<p>Na het bevestigen verander je van de huidige docentenweergave naar de leerlingweergave.</p>\n<p>Indien je later terug wilt gaan naar de docentenweergave kan dit via dezelfde knop.</p>",
          "to_student_button": "Naar leerlingweergave",
          "to_teacher_body": "<p>Na het bevestigen verander je van de huidige leerlingweergave terug naar jouw docentweergave.</p>\n<p>Indien je later terug wilt gaan naar de leerlingweergave kan dit via dezelfde knop.</p>",
          "to_teacher_button": "Naar docentweergave"
        },
        "renew_licenses": "Licenties verversen",
        "renewed_licenses": "Succesvol licenties opgehaald",
        "renewed_licenses_no_new_licenses": "Geen nieuwe licenties gevonden",
        "title_signed_as": "Ingelogd als <b>{{first_name}}</b>",
        "toggle_teacher_student_label": "Bekijk als"
      }
    }
  },
  "learningMetadata": {
    "language": "Taal"
  },
  "legend": {
    "not-completed-review-disabled": {
      "subtitle": "De opdracht is nog niet afgerond en het nakijken staat uit voor deze opdracht.",
      "title": "Niet afgerond & nakijken uitgezet"
    },
    "read-to-check": {
      "subtitle": {
        "bo": "Nakijken staat aan. De student kan de opdracht nakijken.",
        "default": "Nakijken staat aan. De leerling kan de opdracht nakijken.",
        "vo": "Nakijken staat aan. De leerling kan de opdracht nakijken."
      },
      "title": "Klaar om na te kijken"
    },
    "results-cleared": {
      "subtitle": {
        "bo": "De student kan de opdracht opnieuw maken.",
        "default": "De leerling kan de opdracht opnieuw maken.",
        "vo": "De leerling kan de opdracht opnieuw maken."
      },
      "title": "Resultaten gewist"
    },
    "submitted-score-disabled": {
      "subtitle": {
        "bo": "De student heeft de opdracht ingeleverd, maar kan de opdracht niet nakijken.",
        "default": "De leerling heeft de opdracht ingeleverd, maar kan de opdracht niet nakijken.",
        "vo": "De leerling heeft de opdracht ingeleverd, maar kan de opdracht niet nakijken."
      },
      "title": "Ingeleverd maar nakijken uitgezet"
    }
  },
  "modal": {
    "resource_info_modal": {
      "details_empty": "Geen",
      "details_learning_item": "Details leereenheid",
      "in_arrangement": "Onderdeel van arrangement"
    },
    "support_language": {
      "info": "Kies de taal waarin je ondersteuning wilt ontvangen.<br>De taal van de interface verandert niet.",
      "none": "Geen steuntaal"
    }
  },
  "navigation": {
    "skip_to_main_content": "Ga direct naar inhoud"
  },
  "notifications": {
    "messages": {
      "enable_one": "Je docent heeft {{ type }} {{ subject }} aangezet.",
      "enable_other": "Je docent heeft meerdere {{ type }} aangezet.",
      "feedback_created": "Je docent heeft feedback gegeven op de opdracht {{ subject }}.",
      "result_delete_one": "Je docent heeft alle resultaten van {{ type }} '{{ subject }}' verwijderd.",
      "result_delete_other": "Je docent heeft meerdere resultaten van {{ type }} '{{ subject }}' verwijderd.",
      "review_enable_one": "Je docent heeft het nakijken van {{ type }} '{{ subject }}' aangezet.",
      "review_enable_other": "Je docent heeft het nakijken gedeeltelijk binnen {{ type }} '{{ subject }}' aangezet"
    },
    "noun_phrase": {
      "arrangement": "het arrangement",
      "chapter": "het hoofdstuk",
      "itemMap": "het opdrachtenblok",
      "module": "de module",
      "paragraph": "de paragraaf",
      "question": "de opdracht",
      "questionGroup": "de opdrachten groep"
    },
    "title": "Jouw bevindingen",
    "types": {
      "assignment_one": "opdracht",
      "assignment_other": "opdrachten",
      "assignments_block_one": "opdrachtenblok",
      "assignments_block_other": "opdrachtenblokken",
      "chapter_one": "hoofdstuk",
      "chapter_other": "hoofdstukken",
      "paragraph_one": "paragraaf",
      "paragraph_other": "paragrafen"
    }
  },
  "onboarding": {
    "all_available_learning_resources": "Alle beschikbare leermiddelen",
    "all_learning_materials_from_subscription": "Alle methodes",
    "back_to_home": "Naar je lesmateriaal",
    "change_layout": "Indeling aanpassen",
    "continu": "Ga verder",
    "dialog": {
      "multiple": {
        "stream": {
          "select": "Je hebt meer dan 1 voorkeur voor deze methode. Kies het leermiddel dat je nu wilt bekijken."
        },
        "title": "Leermiddel kiezen"
      }
    },
    "method": "Methode",
    "overview": {
      "add_preference": "Voeg je voorkeur toe",
      "create_first": "Voeg hieronder je eerste voorkeur toe. Heb je geen voorkeur? Ga dan naar al jouw lesmateriaal.",
      "create_new": "Je kunt hieronder eventueel nog een voorkeur toevoegen. Heb je geen andere voorkeur? Ga dan naar je lesmateriaal.",
      "description": "Kies hier het lesmateriaal dat je als eerste op je scherm wilt zien (jouw voorkeurslesmateriaal).\n\n",
      "removal_confirmation": "Weet je zeker dat je het lesmateriaal van {{material}} wilt verwijderen uit je voorkeuren?",
      "remove_preference": "Verwijder {{index}}e voorkeur",
      "studymaterial": "Lesmateriaal",
      "title": "Kies je voorkeurslesmateriaal",
      "titles": "Leermiddelen"
    },
    "page-title": "Welkom bij het online lesmateriaal van ThiemeMeulenhoff",
    "page-title-homepage": "Online lesmateriaal ThiemeMeulenhoff",
    "page-title-preferred-materials": "Overzicht voorkeuren",
    "page-title-select": "Leermiddelen kiezen",
    "page-title-select-method": "Voorkeurslesmateriaal kiezen",
    "preference": {
      "custom_arrangements": {
        "title": "Samengesteld lesmateriaal"
      },
      "edit": {
        "choose_material": "Kies een methode",
        "choose_titles": "Kies leermiddel(en)",
        "description": "Klik op een methode. Er verschijnt dan een lijst leermiddelen. Kies de middelen die je het meest gebruikt en klik op ‘Opslaan’.\n\nJe mag later voorkeuren verwijderen, aanpassen of toevoegen. En je houdt altijd toegang tot al het bestelde lesmateriaal.",
        "index_preference": "Voorkeur {{index}}",
        "option": {
          "subtitle": "Voorkeur {{number}}"
        },
        "select_material": "Zoek of selecteer een methode",
        "titles_description": "Kies 1 of meer leermiddelen die je als eerste wilt zien op je scherm."
      }
    },
    "preferences": {
      "add": {
        "description": "Kies het lesmateriaal dat je het meest gebruikt. Je kunt je voorkeur(en) later aanpassen. ",
        "leave_confirm": "De selectie die je hebt gemaakt wordt niet opgeslagen",
        "stream": {
          "description": "Kies voor deze methode het lesmateriaal dat je het meest gebruikt. Je kunt je voorkeur(en) later aanpassen."
        },
        "title": "Kies je voorkeur",
        "validation": "Kies minimaal 1 leermiddel om verder te gaan.",
        "validation_method": "Maak een selectie om verder te gaan."
      },
      "learning_tool_back": "Terug naar leermiddel",
      "material_back": "Terug naar je lesmateriaal",
      "overview_back": "Terug naar het overzicht van jouw voorkeuren",
      "to_homepage": "Naar je lesmateriaal",
      "welcome_back": "Terug naar welkom"
    },
    "prefix_teaching_materials": "Leermiddelen van {{method}}",
    "skip": "Overslaan",
    "start": "Start",
    "student_welcome": "Ga verder met jouw lesmateriaal",
    "teaching_materials_prepared_by_your_teacher": "Door je docent klaargezet lesmateriaal",
    "title": "Leermiddelen",
    "welcome": {
      "activation_message": "Op de volgende pagina zie je al het bestelde lesmateriaal. Vervolgens kan je aangeven welk deel van dit materiaal je het meest gebruikt. Dan laten we dat als eerste op je scherm zien. Dit noemen we jouw ‘voorkeurslesmateriaal’.",
      "description": "Let op: je houdt gewoon toegang tot de rest van het bestelde lesmateriaal. En het is niet verplicht om je voorkeur(en) door te geven. Doe je dit wel? Dan kun je jouw voorkeur(en) altijd weer veranderen. Klik op Start om naar het lesmateriaal te gaan!",
      "renew_licenses_button": "Ophalen nieuwe licenties",
      "renew_licenses_message": "Je hebt nog geen actieve licentie. Heb je geen activeringscode of weet je niet hoe je die moet gebruiken? Vraag je docent of ICT-coördinator hoe je bij je lesmateriaal kunt komen. Na het activeren kun je de nieuwe licentie ophalen via deze pagina en aan de slag met het online lesmateriaal.",
      "title": "Welkom bij jouw online lesmateriaal!"
    }
  },
  "onegate": {
    "forgot_password_success": {
      "message": "We hebben je een e-mail gestuurd zodat je\neen nieuw wachtwoord kunt instellen.",
      "title": "E-mail verstuurd"
    },
    "forgot_password": {
      "info": "We sturen je een link naar het volgende e-mailadres zodat je een nieuw wachtwoord in kan stellen.",
      "send_link": "Stuur mij de link"
    },
    "initiate_set_password_success": {
      "message": "Als er een account voor dit e-mailadres bestaat, hebben we een e-mail gestuurd met een nieuwe link om je wachtwoord in te stellen.",
      "title": "E-mail verstuurd"
    },
    "initiate_set_password": {
      "info": "Vul je e-mailadres in om een link te ontvangen waarmee je een wachtwoord kunt instellen.",
      "send_link": "Stuur mij de link",
      "title": "Stel je wachtwoord in"
    },
    "institution_invitation": {
      "error": {
        "codes": {
          "internal_error": "Er is iets misgegaan. Probeer het later opnieuw.",
          "invalid_link": "Deze link is ongeldig of beschadigd. Vraag een nieuwe link aan bij je beheerder.",
          "not_found": "Deze uitnodiging is niet gevonden of verlopen.",
          "unknown": "De koppeling kon niet worden voltooid."
        },
        "title": "Koppeling niet gelukt"
      },
      "success": {
        "continue_button": "Naar mijn licenties",
        "message": "Je bent gekoppeld als beheerder van het instituut.",
        "message_admin": "Je bent gekoppeld als beheerder van het instituut.",
        "message_teacher": "Je bent gekoppeld als docent van het instituut.",
        "title": "Instituut gekoppeld"
      }
    },
    "licenses": {
      "activation_code_tooltip": "Je vindt deze code in je lesmateriaal of in je e-mail.",
      "error": {
        "code_already_used": "Deze activatiecode is al eens gebruikt",
        "code_invalid": "Dit is geen geldige activatiecode",
        "code_unknown": "Deze activatiecode is onbekend",
        "unknown": "Onbekende activatiecode"
      },
      "expired_since": "Verlopen op",
      "leave": "Naar de lessen",
      "list_title": "Jouw licenties ({{count}})",
      "no_active_licenses": "Dit account heeft nog geen actieve licentie.",
      "no_license": {
        "student_bold": "Ben je een NT2-student?",
        "student_link": "leermiddelenlijst",
        "student_text": "Koop je boeken met licenties bij je lokale boekhandel of online via bol.com. Check de",
        "student_text_after": "van je school en vraag je docent welke boeken je nodig hebt.",
        "teacher_bold": "Ben je een docent?",
        "teacher_link": "webshop van Thiememeulenhoff",
        "teacher_text": "Bezoek de",
        "teacher_text_after": "om een licentie of lesmateriaal te kopen.",
        "title": "Nog geen licentie?"
      },
      "title": "Licenties beheren",
      "title_new_user": "Nog één stap om te beginnen",
      "valid_until": "Geldig tot"
    },
    "login": {
      "email_not_found": "Dit e-mailadres wordt niet herkend. Pas het bovenstaande e-mailadres aan of klik hieronder op ‘Account aanmaken’.",
      "error": {
        "email_not_validated": "Je e-mailadres is nog niet bevestigd. Bekijk je inbox voor de bevestigingsmail of vraag een nieuwe aan.",
        "password_incorrect": "De combinatie van gebruikersnaam/e-mailadres en wachtwoord is onjuist.",
        "resend_validation_email": "Validatiemail opnieuw versturen",
        "title": "Inloggen mislukt"
      },
      "header": "Aanmelden met je account",
      "header_password": "Voer je wachtwoord in",
      "login_with_email": "Aanmelden met e-mail",
      "validation_email_resent": "We hebben een nieuwe validatiemail verstuurd. Bekijk je inbox."
    },
    "password_tooltip": "Het wachtwoord moet voldoen aan de volgende eisen: Een minimale lengte van 9 karakters; Minimaal 1 numeriek karakter (0 t/ m 9); Minimaal 2 alfanumerieke karakters, waarvan 1 hoofdletter (A t/m Z) en 1 kleine letter (a t/m z); Minimaal 1 speciaal karakter (bijvoorbeeld !@#$%^&*()?><€=_+-).",
    "register_success": {
      "message": "We hebben je een verificatiemail gestuurd. Klik op de link in de e-mail om je account te bevestigen en in te loggen.",
      "title": "Verifieer je account"
    },
    "register": {
      "error": {
        "user_already_exists": "Er bestaat al een account met dit e-mailadres."
      },
      "header": "Account aanmaken"
    },
    "reset_password_success": {
      "message": "Je wachtwoord is met succes gewijzigd",
      "title": "Wachtwoord gewijzigd"
    },
    "reset_password": {
      "change_button": "Wijzig wachtwoord",
      "info": "Vul hieronder tweemaal een nieuw wachtwoord in om het wachtwoord te herstellen voor het e-mailadres:"
    },
    "set_password_success": {
      "message": "Je wachtwoord is met succes ingesteld. Je kunt nu inloggen.",
      "title": "Wachtwoord ingesteld"
    },
    "set_password": {
      "error": {
        "password_already_set": "Er is al een wachtwoord ingesteld voor dit account. Probeer in te loggen of gebruik 'Wachtwoord vergeten'.",
        "token_invalid": "Deze link is ongeldig of verlopen. Vraag een nieuwe link aan."
      },
      "info": "Vul tweemaal een wachtwoord in om het account voor onderstaand e-mailadres te activeren:",
      "invalid_token": "Deze link is ongeldig of verlopen.",
      "submit_button": "Stel wachtwoord in",
      "title": "Stel je wachtwoord in"
    },
    "toegang_password_setup": {
      "info": "Je account is al bekend bij ThiemeMeulenhoff. De NT2-omgeving werkt met een wachtwoord. Klik hieronder om een e-mail te ontvangen waarmee je een wachtwoord instelt.",
      "title": "Je hebt al een account"
    },
    "unknown_error": "Er is een onverwachte fout opgetreden",
    "validation_success": {
      "message": "Je account is succesvol geverifieerd. Je kunt nu inloggen.",
      "title": "Account geverifieerd"
    },
    "verify_set_password_token": {
      "error": {
        "token_invalid": "Deze link is ongeldig of verlopen. Vraag een nieuwe link aan."
      }
    }
  },
  "poc": {
    "chatbot": {
      "ai_assistant": "Chat over de stof",
      "cta": "Stel je vraag",
      "cta_contents": "Wil je hulp bij de lesstof?",
      "cta_contents_start": "Chat over de stof",
      "cta_teacher_material": "Maak extra lesmateriaal",
      "explanation": "Deze chat helpt je bij het oefenen met de stof. Vraag om uitleg, laat het een opdracht maken of laat het je helpen met plannen.\nControleer informatie altijd zelf.",
      "input-placeholder": "Typ hier je bericht",
      "intro-description": "Deze chat helpt je bij het oefenen met de lesstof. Vraag om uitleg, laat het een opdracht maken of laat het je helpen met plannen.\nControleer informatie altijd zelf.",
      "intro-header": "Typ een bericht of kies een actie",
      "intro1": "Geef uitleg over de lesstof",
      "intro2": "Maak een oefenopdracht",
      "intro3": "Help met een planning",
      "loading": "Antwoord aan het ophalen...",
      "no-connection": "Het lijkt erop dat de chat momenteel niet beschikbaar is. Dit probleem kan meerdere oorzaken hebben. Probeer het later nog eens.",
      "no-session": "Aan het verbinden met de chat..."
    }
  },
  "print": {
    "reader": {
      "configuration": {
        "confirm_action": "Reader maken en bekijken",
        "description": {
          "description": "De omschrijving komt in de webwinkel bij de reader te staan.",
          "label": "Omschrijving"
        },
        "edit": {
          "confirm_action": "Opslaan",
          "header": "Reader bewerken"
        },
        "header": "Reader maken",
        "readertype": {
          "label": "Readertype",
          "theory-book": {
            "description": "De reader bevat vooral uitleg en theorie.",
            "subtitle": "Alleen uitleg en theorie, zonder invulruimte.",
            "title": "Theorieboek"
          },
          "theory-work-book": {
            "description": "De reader bevat theorie, opdrachten en ruimte om antwoorden in te vullen.",
            "subtitle": "Theorie, opdrachten en schrijfruimte in één reader.",
            "title": "Leer-werkboek"
          },
          "work-book": {
            "description": "De reader bevat opdrachten met ruimte om antwoorden in te vullen.",
            "subtitle": "Opdrachten en invulruimte om in te werken.",
            "title": "Werkboek"
          }
        },
        "school-name": {
          "label": "Schoolnaam"
        },
        "sub-title": {
          "label": "Ondertitel"
        },
        "subtitle": "Maak een reader op basis van \"{{arrangement}}\".",
        "title": {
          "default-suffix": "Reader",
          "label": "Readertitel",
          "warning": "Titel is verplicht."
        },
        "toaster": {
          "archive-success": {
            "title": "Reader ingetrokken"
          },
          "delete-success": {
            "title ": " Reader verwijderd",
            "title": "Reader verwijderd"
          },
          "error-archive": {
            "description": "Er is een fout opgetreden bij het intrekken van een reader.",
            "title": "Reader intrekken mislukt"
          },
          "error-delete": {
            "description": "Er is een fout opgetreden bij het verwijderen van een reader. Probeer het later opnieuw of neem contact op met support.",
            "title": "Verwijderen mislukt"
          },
          "error-publish": {
            "description": "Er is een fout opgetreden bij het publiceren van een reader.",
            "title": "Reader publiceren mislukt"
          },
          "error-recover": {
            "description": "Er is een fout opgetreden bij het opnieuw bestelbaar maken van een reader.",
            "title": "Opnieuw bestelbaar maken mislukt"
          },
          "error": {
            "description": "Er is een fout opgetreden bij het opslaan van de reader.",
            "title": "Reader opslaan mislukt"
          },
          "publish-success": {
            "description": "Je krijgt een melding zodra de bestellink beschikbaar is.",
            "title": "Reader wordt klaargezet."
          },
          "success": {
            "title": "Reader opgeslagen"
          },
          "update-success": {
            "title": "Readergegevens bijgewerkt"
          }
        }
      }
    },
    "resource": {
      "terms": {
        "title": "Begrippen"
      }
    }
  },
  "qr_code_label": {
    "audio": "Luister dit audio fragment.",
    "document": "Download:",
    "video": "Bekijk deze video."
  },
  "reader": {
    "status": {
      "archived": "Ingetrokken",
      "draft": "In afwachting",
      "failed": "Mislukt",
      "generated": "Concept",
      "generating": "PDF wordt gegenereerd...",
      "processed": "Bestelbaar",
      "processing": "Wordt klaargezet",
      "ready": "Bestelbaar",
      "too-few-pages": "Te weinig pagina's",
      "too-many-pages": "Te veel pagina's"
    }
  },
  "resource": {
    "contents": {
      "label": {
        "introduction": "Oriëntatieopdrachten"
      },
      "only_show_assignments": "Toon alleen opdrachten"
    },
    "sources": {
      "alphabetical": "Alfabetisch",
      "chapter": "Standaard",
      "filter_selected": "{{count}} filters geselecteerd",
      "select_filter": "Selecteer filters",
      "sort": "Sorteer"
    },
    "terms": {
      "chapter": "Hoofdstuk",
      "filter_selected_one": "{{count}} filter geselecteerd",
      "filter_selected_other": "{{count}} filters geselecteerd",
      "select_filter": "Selecteer filters",
      "sort": "Sorteer"
    }
  },
  "results-detail-status": {
    "assignment": {
      "off": "Opdracht uitgeschakeld",
      "on": "Opdracht ingeschakeld"
    },
    "check": {
      "off": "Nakijken uitgezet",
      "on": "Nakijken aangezet"
    },
    "show-answer-clicked": "De leerling heeft op 'toon antwoord' geklikt"
  },
  "results-detail": {
    "back-to-results": "Terug naar Resultaten",
    "behaviour-signals": {
      "attempt": "Poging {{attempt}} · {{phrase}}",
      "attempt_duration": "Poging {{attempt}} duur · {{seconds}}s",
      "between_attempts": "Tussen poging {{fromAttempt}}/{{toAttempt}} · {{phrase}}",
      "between_attempts_duration": "Tussen poging {{fromAttempt}}/{{toAttempt}} · {{seconds}}s",
      "expected_vs_actual": "Verwachting · {{verdict}}",
      "expected_vs_actual_sentinel": "Verwachting · {{phrase}}",
      "peer_attempt_count": "Gem. pogingen klas: {{attempts}}",
      "peer_attempt_count_sentinel": "Geen klasgenoten",
      "peer_average": "Gem. · {{score}}%",
      "peer_average_sentinel": "Gem. · {{phrase}}",
      "peer_time_on_first_attempt": "Gem. 1e poging klas: {{seconds}}s",
      "peer_time_on_first_attempt_sentinel": "Geen klasgenoten",
      "phrase": {
        "no_peer_attempts": "geen pogingen",
        "no_question_history": "geen vraaggeschiedenis",
        "no_start_time": "geen starttijd",
        "not_graded": "niet beoordeeld",
        "previous_not_graded": "vorige niet beoordeeld"
      },
      "recent_average": "Gem. recente pogingen: {{score}}%",
      "recent_average_sentinel": "Geen recente pogingen",
      "verdict": {
        "as_expected": "zoals verwacht",
        "better_than_expected": "beter dan verwacht",
        "worse_than_expected": "slechter dan verwacht"
      }
    },
    "sidebar": {
      "title": "Groep"
    },
    "toaster": {
      "check": {
        "subtitle": {
          "false": "Het nakijken van de opdracht is aangezet",
          "true": "Het nakijken van de opdracht is uitgezet"
        },
        "title": "De opdracht nakijken is aangepast"
      },
      "delete": {
        "subtitle": "Het verwijderen van het resultaat is voltooid",
        "title": "resultaten zijn gewist"
      },
      "disable": {
        "subtitle": {
          "false": "De opdracht is aangezet",
          "true": "De opdracht is uitgezet"
        },
        "title": "De opdracht is aangepast"
      }
    }
  },
  "results-options": {
    "check-activate-deactivate": "Nakijken aan-/uitzetten",
    "clear-result": "Resultaten wissen",
    "fetch-only-my-groups-toggle": "Alleen mijn groepen",
    "last-name-first-toggle": "Achternaam eerst",
    "show-teachers-toggle": "Toon docenten",
    "title": "Opties",
    "turn-assignments-on-off": "Opdrachten aan-/uitzetten"
  },
  "results": {
    "actions": {
      "bar": {
        "button": {
          "cancel": "Annuleren",
          "check": "Nakijken aan-/uitzetten",
          "delete": "Resultaten wissen",
          "disable": "Opdrachten aan-/uitzetten"
        },
        "confirm_button": {
          "check": "Ja, aanpassen",
          "delete": "Ja, wissen",
          "disable": "Ja, aanpassen"
        },
        "confirm_cancel_button": {
          "delete": "Ja, annuleren",
          "delete_cancel": "Doorgaan met wissen"
        },
        "confirm_cancel_message": {
          "delete": "Het proces van resultaten wissen is nog niet voltooid.<br>Weet je zeker dat je dit wilt annuleren?"
        },
        "confirm_cancel_title": {
          "delete": "Wissen annuleren?"
        },
        "confirm_message": {
          "check": "Dit bepaalt of leerlingen de opdracht kunnen nakijken.<br>\nWeet je zeker dat je dit wilt aanpassen?",
          "delete": "Het wissen van resultaten kan niet ongedaan worden gemaakt.<br>Weet je zeker dat je wilt doorgaan?",
          "disable": "Scores van uitgezette opdrachten worden niet meegerekend in de gemiddelde score. Weet je zeker dat je dit wilt aanpassen?",
          "false": {
            "check": "Deze actie bepaalt dat het nakijken van de opdracht wordt uitgezet.<br />Weet je zeker dat je dit wilt aanpassen?",
            "disable": "Deze actie bepaalt dat de opdracht wordt uitgezet.<br />Weet je zeker dat je dit wilt aanpassen?"
          },
          "true": {
            "check": "Deze actie bepaalt dat het nakijken van de opdracht wordt aangezet.<br />Weet je zeker dat je dit wilt aanpassen?",
            "disable": "Deze actie bepaalt dat de opdracht wordt aangezet.<br />Weet je zeker dat je dit wilt aanpassen?"
          }
        },
        "confirm_title": {
          "check": "Nakijken aan-/uitzetten?",
          "delete": "Resultaten wissen?",
          "disable": "Opdrachten aan-/uitzetten?",
          "false": {
            "check": "Nakijken uitzetten",
            "disable": "Opdracht uitzetten"
          },
          "true": {
            "check": "Nakijken aanzetten",
            "disable": "Opdracht aanzetten"
          }
        },
        "explanation": "Deze wijziging bewaart je instellingen op een lager niveau.",
        "loading_error": "Het ophalen van de gegevens voor je groep is niet gelukt, omdat er een technisch probleem is.<br>Probeer het het later nog een keer. Lukt het later nog niet, <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">neem dan contact op met de klantenservice.",
        "selected": "{{ count }} geselecteerd"
      }
    },
    "average_score_tooltip": "Gemiddelde score: {{ score }}%",
    "detail": {
      "assignment-tracker": "Opdracht {{index}} van {{total}}"
    },
    "fetch_error": "Het ophalen van de resultaten voor je groep is niet gelukt, omdat er een technisch probleem is. Probeer het het later nog een keer. Lukt het later nog niet, <a href=\"https://www.thiememeulenhoff.nl/contact\" target=\"_blank\">neem dan contact op met de klantenservice.",
    "legend": {
      "item": {
        "marginal": {
          "description": "Een (gemiddelde) score van 40% t/m 60%.",
          "label": "In ontwikkeling – verdere oefening gewenst"
        },
        "not-started": {
          "description": "De opdracht is nog niet gestart of afgerond.",
          "label": "Niet afgerond"
        },
        "open-question": {
          "description": "De {{ studentType }} beoordeelt opdracht zelf.",
          "label": "Zelfscore",
          "subtitle": {
            "bo": "De student beoordeelt de opdracht zelf.",
            "default": "De leerling beoordeelt de opdracht zelf.",
            "vo": "De leerling beoordeelt de opdracht zelf."
          }
        },
        "poor": {
          "description": "Een (gemiddelde) score t/m 40%.",
          "label": "Basis ontbreekt – gerichte interventie nodig"
        },
        "satisfactory": {
          "description": "Een (gemiddelde) score vanaf 60%.",
          "label": "Op basisniveau – kan door naar volgend onderdeel"
        }
      },
      "title": "Legenda"
    },
    "no_group_selected_description": "Er is geen groep geselecteerd. Selecteer een groep om daarvan de resultaten in te zien.",
    "no_group_selected_title": "Geen groep geselecteerd",
    "no_results_description": "Er zijn geen resultaten gevonden. Probeer een andere groep of stream.",
    "no_results_title": "Geen resultaten gevonden",
    "no_score_tooltip": "Geen score",
    "page-title-label": {
      "chapter": "Hoofdstuk",
      "itemMap": "Opdrachtenblok",
      "module": "Module",
      "paragraph": "Paragraaf"
    },
    "score_tooltip": "Score: {{ score }}%",
    "select_groups": "Selecteer een groep",
    "table": {
      "average-title": "Gemiddelde",
      "names-title": "Naam",
      "progress-title": "Voortgang",
      "user-average-title": "Gemiddelde",
      "user-average-title-short": "Gem."
    },
    "title": "Resultaten",
    "toolbar": {
      "student-name-toggle": "Namen verbergen"
    }
  },
  "score": {
    "legend": {
      "empty": {
        "subtitle": "Scores van uitgezette opdrachten tellen niet mee en zijn niet zichtbaar.",
        "title": "Opdracht uitgezet"
      }
    }
  },
  "sidebar": {
    "aria-label": {
      "collapse": "Zijbalk inklappen",
      "expand": "Zijbalk uitklappen"
    }
  },
  "sidenav": {
    "custom-content": "TM op maat",
    "home": "Home",
    "practiceMaterial": "Oefenen",
    "results": "Resultaten",
    "select_arrangement": "Kies jouw lesmateriaal",
    "studymaterial": "Lesmateriaal",
    "teachermaterial": "Docentmateriaal"
  },
  "teacher-material-articles": {
    "exam-training": "Examenvoorbereiding",
    "exam-training-description": "Hier vind je materiaal dat je kunt gebruiken bij de voorbereiding op de examens.",
    "extra-teacher-material": "Extra lesmateriaal",
    "extra-teacher-material-description": "Hier vind je extra lesmateriaal van ThiemeMeulenhoff en andere aanbieders dat je kunt gebruiken bij je lessen.",
    "extra-work-methods": "Extra werkvormen",
    "extra-work-methods-description": "Hier vind je inspirerende werkvormen om je leerlingen actief aan de slag te laten gaan. Laat ze video's bekijken, artikelen verwerken en op een interactieve manier leren."
  },
  "teacher-material": {
    "articles": {
      "description": "Hier vind je inspirerende werkvormen en lesmateriaal om je leerlingen actief aan de slag te laten gaan. Laat ze video's bekijken, artikelen verwerken en op een interactieve manier leren.",
      "learning_time_indicator": "{{ amount }} minuten",
      "title": "Extra werkvormen en lesmateriaal"
    },
    "button": {
      "show_less": "Toon minder",
      "show_more": "Toon alles"
    },
    "chapters": {
      "title": "Hoofdstukken"
    },
    "filter-no-result": "Geen extra materiaal",
    "filter": {
      "chapter_all": "Alle hoofdstukken",
      "everything": "Al het docentmateriaal",
      "general": "Algemeen {{ arrangement }}",
      "module_all": "Alle modules",
      "paragraph_all": "Alle paragrafen"
    },
    "general": {
      "title": "Algemeen"
    },
    "instructor-assets": {
      "title": "Ondersteunend lesmateriaal"
    },
    "more": {
      "title": "Meer voor docenten"
    },
    "no_search_result_filter": "Geen resultaten gevonden voor <b>'{{ query }}'</b>. Probeer een ander zoekwoord of filter voor nieuwe resultaten.",
    "title": "Docentmateriaal"
  },
  "teachermaterial": {
    "getting": {
      "started": "Docentmateriaal {{ subject }} {{ secondSubject }}"
    },
    "to_teaching_material": "Terug naar lesmateriaal"
  },
  "timing": {
    "pipe": {
      "and": "en",
      "hour": "uur",
      "hours": "uren",
      "minute": "minuut",
      "minutes": "minuten",
      "no-time-set": "geen tijd geregistreerd",
      "second": "seconde",
      "seconds": "seconden"
    }
  },
  "tour": {
    "back": "Terug",
    "close": "Sluiten",
    "complete": "Sluiten",
    "next": "Volgende",
    "skip": "Overslaan",
    "skip-step": "Stap overslaan",
    "start": "Start",
    "welcome": {
      "1": {
        "text": "Welkom in de vernieuwde digitale leeromgeving! Ervaar de nieuwe uitstraling en verbeterde navigatie. Vanaf nu ga je nog makkelijker aan de slag met het online lesmateriaal.\n\nIn deze korte rondleiding laten we je zien waar je de belangrijkste onderdelen vindt, zoals de lesstof, het docentmateriaal en de resultaten. Zo ben je in 1 minuut weer up-to-date. Liever zelf rondkijken? Je kunt de rondleiding natuurlijk ook overslaan.",
        "title": "Welkom in het nieuwe eDition - Start de rondleiding"
      },
      "2": {
        "text": "Zoek en kies een bestaand leermiddel uit de lijst of stel zelf een leermiddel samen.",
        "title": "Kies je lesmateriaal"
      },
      "3": {
        "text": "Hier zie je de methode van jouw keuze. Je wisselt hier makkelijk tussen verschillende methodes.",
        "title": "Jouw gekozen methode"
      },
      "4": {
        "text": "Hier navigeer je makkelijk naar de verschillende onderdelen van het lesmateriaal. Selecteer de methodenaam voor een overzicht met alle leermiddelen van de methode.",
        "title": "Methode-overzicht"
      },
      "5": {
        "text": "Hier vind je het leermiddel van jouw keuze. Via deze knop schakel je makkelijk tussen de verschillende leermiddelen van deze methode.",
        "title": "Jouw gekozen leermiddel"
      },
      "6": {
        "text": "Hier vind je het lesmateriaal binnen jouw gekozen leermiddel, zoals de theorie en de opdrachten.",
        "title": "Lesmateriaal"
      },
      "7": {
        "text": "Hier vind je het docentmateriaal van jouw gekozen leermiddel.",
        "title": "Docentmateriaal"
      },
      "8": {
        "text": "Via Resultaten bekijk je de resultaten en de voortgang van je {{studentType}}.",
        "title": "Resultaten"
      },
      "9": {
        "text": "Veel plezier met het werken in de jouw nieuwe digitale leeromgeving. Kom je ergens niet uit? Je kunt de rondleiding altijd opnieuw doorlopen via jouw persoonlijke menu. Heb je nog andere vragen? Onze <a href=\"https://www.thiememeulenhoff.nl/klantenservice\" target=\"_blank\">klantenservice</a> helpt je graag verder.",
        "title": "Tot slot: jouw persoonlijke menu"
      }
    }
  },
  "train": {
    "word": {
      "new": "Nieuw woord: lees het en onthoud de vertaling"
    }
  },
  "trainer": {
    "banner": {
      "intro": "Oefen de woorden van {{ title }}",
      "title": "Ga naar oefenen"
    },
    "detail": {
      "count": "{{ total }} woorden",
      "done-for-today": "Geleerd",
      "mastered": "Beheerst",
      "previously-mastered": "Herhaling nodig",
      "seen": "Gestart",
      "unseen": "Niet gestart"
    },
    "end": {
      "continue": "Verder oefenen",
      "overview": "Naar overzicht",
      "session": "Je hebt deze sessie {{ sessionTime }} geoefend. In totaal heb je {{ overallTime }} geleerd met deze lijst.",
      "subtitle": "Je hebt {{ amount }} badge(s) behaald voor {{ type }} in de richting {{ direction }} . Morgen kun je verder oefenen voor de volgende badge.",
      "title": "Goed gedaan, je kent alles voor vandaag!",
      "train": "Oefen in andere richting"
    },
    "feedback": {
      "correct": "Goed",
      "incorrect": "Fout"
    },
    "finish-session": "Beëindig sessie",
    "hero": {
      "title": "VERDER MET JE LAATST GEOEFENDE LIJST"
    },
    "intro": {
      "continue": "Gelezen",
      "new-word": "Nieuw"
    },
    "list-count": "{{ index }} lijsten",
    "list": {
      "open": "Open trainerlijst {listname}"
    },
    "mobile": {
      "title": "Oefenen"
    },
    "no-lists-found": "Geen lijsten gevonden. Pas je zoekopdracht of filter aan.",
    "overview": {
      "list": {
        "title": "Alle lijsten van {{title}}"
      },
      "prefix-subtitle": "Module {{ module }} -",
      "show-all": "Toon alle lijsten ({{count}})",
      "subtitle": "{{ paragraphNumber }} — {{ paragraphTitle }}"
    },
    "paragraph": {
      "title": "Woorden in deze paragraaf"
    },
    "practice": {
      "back": "Terug naar oefenmatriaal",
      "direction": "Oefenrichting",
      "drill": "Oefenvorm",
      "start": "Start oefenen",
      "title": "Oefen lijst"
    },
    "progress": "{{ percentage }}% klaar voor vandaag",
    "question-type": {
      "multiple-choice": "Meerkeuze"
    },
    "result": {
      "correct": "Antwoorden goed: {{ count }}",
      "incorrect": "Antwoorden fout: {{ count }}",
      "title": "Sessie beindigd",
      "total-time": "Duur sessie: {{ time }}"
    },
    "select-answer": "Selecteer het juiste antwoord",
    "start": {
      "subtitle": "De oefensessie start over…",
      "to-trainer": "Naar de trainer"
    },
    "swap": "Wissel oefenrichting",
    "title": "Oefenen",
    "tooltip": {
      "done_for_today": "Je hebt deze voldoende geleerd! Herhaal ze morgen om ze te blijven onthouden.",
      "mastered": "Je hebt deze beheerst door ze op meerdere dagen te leren.",
      "previously_mastered": "Je hebt deze eerder geleerd. Herhaal ze om ze te blijven onthouden. ",
      "seen": "Je bent begonnen met oefenen. Oefen deze vandaag om ze te beheersen.",
      "unseen": "Je bent nog niet begonnen met oefenen. Oefen deze vandaag om ze te beheersen."
    },
    "total": {
      "badges": "{{ amount}} van {{ total }} behaald",
      "badges-max": "{{ amount}} behaald"
    },
    "train": "Oefen",
    "type": {
      "multi": "Multiple choice",
      "speak": "Spraak",
      "type": "Typen"
    },
    "words-count": " woorden"
  },
  "unsaved_changes_modal": {
    "description": "Je wijzigingen zijn niet opgeslagen. Als je de pagina verlaat dan verlies je mogelijk je voortgang.",
    "title": "Niet opgeslagen"
  },
  "voucher": {
    "modal": {
      "action": {
        "copy": "Kopieer code",
        "toaster": {
          "copy_code": "Voucher code toegewezen."
        }
      },
      "deviant": {
        "action": {
          "open_link": "Door naar Startrekenen"
        },
        "error": {
          "pool_exhausted": "Er zijn geen vouchers meer beschikbaar."
        },
        "instructions": {
          "step_1": "Log in op www.studiemeter.nl.",
          "step_2": "Klik in het linkermenu op Lesmateriaal.",
          "step_3": "Klik op + Activatiecode invoeren.",
          "step_4": "Voer de activatiecode in en klik op Activeren.",
          "step_5": "Mogelijk moet de pagina daarna nog worden ververst voordat het lesmateriaal zichtbaar is."
        },
        "subtitle": "Om gebruik te maken van de digitale omgeving van Startrekenen heb je een vouchercode nodig.",
        "title": "Vouchercode Startrekenen Verpleegkundig rekenen",
        "valid_until": "Deze voucher is geldig tot {{ validUntil }}"
      },
      "error": {
        "generic": "Er is fout gegaan, neem contact op met de ThiemeMeulenhoff klanten service."
      }
    }
  },
  "zip": {
    "status": {
      "downloading": "Downloaden: {{fileName}}",
      "finished": "Downloaden voltooid: {{fileName}}",
      "idle": "Downloaden voltooid: {{fileName}}",
      "zipping": "Zippen: {{fileName}}"
    }
  }
}
